<template>
  <div class="home">
    <MyHeader title="market"></MyHeader>
    <div class="left-bar"></div>
    <div class="right-bar"></div>
    <div class="bottom-bar"></div>
    <div class="content">
      <div class="box_3 flex-col">
        <div class="block_1 flex-row">
          <div class="group_1 flex-col justify-between">
            <div class="block_2 flex-col">
              <div class="box_4 flex-row">
                <span class="text_3">工商联地方组织发展情况</span>
                <div class="group_2 flex-row justify-end">
                  <span class="text_4">工商联会员发展情况</span>
                  <div class="box_5 flex-col"></div>
                </div>
                <span class="text_5">工商联商会组织发展情况</span>
              </div>
              <div class="text-wrapper_2">
                <span class="text_6"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;截至2024年12月底，全省工商联共有会员&nbsp;</span
                >
                <span class="text_7">520461</span>
                <span class="text_8">&nbsp;&nbsp;个，比2023年增加&nbsp;</span>
                <span class="text_9">9792</span>
                <span class="text_10">&nbsp;&nbsp;个，增长&nbsp;</span>
                <span class="text_11">1.92%</span>
                <span class="text_12">&nbsp;&nbsp;。其中，企业会员&nbsp;</span>
                <span class="text_13">436706</span>
                <span class="text_14">&nbsp;&nbsp;个，占会员总数的&nbsp;</span>
                <span class="text_15">83.91%</span>
                <span class="text_16">&nbsp;&nbsp;；&nbsp;团体会员&nbsp;</span>
                <span class="text_17">3800</span>
                <span class="text_18">&nbsp;&nbsp;个，占会员总数的&nbsp;</span>
                <span class="text_19">0.73%</span>
                <span class="text_20">&nbsp;&nbsp;；&nbsp;个人会员&nbsp;</span>
                <span class="text_21">79955</span>
                <span class="text_22">&nbsp;&nbsp;个，占会员总数的&nbsp;</span>
                <span class="text_23">15.36%</span>
                <span class="text_24"
                >&nbsp;&nbsp;。从地市分布来看，会员数量位居前五位的地市是深圳市（&nbsp;</span
                >
                <span class="text_25">92055</span>
                <span class="text_26">&nbsp;&nbsp;个）、佛山市（&nbsp;</span>
                <span class="text_27">56266</span>
                <span class="text_28">&nbsp;&nbsp;个）、广州市（&nbsp;</span>
                <span class="text_29">55846</span>
                <span class="text_30">&nbsp;&nbsp;个）、东莞市（&nbsp;</span>
                <span class="text_31">31686</span>
                <span class="text_32">&nbsp;&nbsp;个）、江门市（&nbsp;</span>
                <span class="text_33">27339</span>
                <span class="paragraph_1"
                >&nbsp;&nbsp;个）。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;从执委会建设情况来看，省、市、县三级工商联执委会成员合计&nbsp;</span
                >
                <span class="text_34">20281</span>
                <span class="text_35"
                >&nbsp;&nbsp;名，其中在各级人大任职的有&nbsp;</span
                >
                <span class="text_36">1927</span>
                <span class="text_37"
                >&nbsp;&nbsp;名&nbsp;；&nbsp;各级政协任职的有</span
                >
                <span class="text_38">5222</span>
                <span class="text_39"
                >&nbsp;&nbsp;名。省工商联执委会成员&nbsp;</span
                >
                <span class="text_40">431</span> <span class="text_41"></span>
                <span class="text_42"
                >&nbsp;名，其中在各级人大任职的有&nbsp;</span
                >
                <span class="text_43">111</span>
                <span class="text_44"
                >&nbsp;&nbsp;名&nbsp;；&nbsp;各级政协任职的有&nbsp;</span
                >
                <span class="text_45">224</span>
                <span class="text_46"
                >&nbsp;&nbsp;名。21个地级以上市&nbsp;工商联执委会成员合计&nbsp;</span
                >
                <span class="text_47">5036</span>
                <span class="text_48"
                >&nbsp;&nbsp;名，其中在各级人大任职的有&nbsp;</span
                >
                <span class="text_49">443</span>
                <span class="text_50"
                >&nbsp;&nbsp;名；各级政协任职的有&nbsp;</span
                >
                <span class="text_51">1005</span>
                <span class="text_52"
                >&nbsp;&nbsp;名。各县级工商联执委会成员合计&nbsp;</span
                >
                <span class="text_53">14814</span>
                <span class="text_54"
                >&nbsp;&nbsp;名，其中在各级人大任职的有&nbsp;</span
                >
                <span class="text_55">1373</span>
                <span class="text_56"
                >&nbsp;&nbsp;名&nbsp;；&nbsp;各级政协任职的有&nbsp;</span
                >
                <span class="text_57">3993</span>
                <span class="text_58">&nbsp;&nbsp;名。</span>
              </div>
            </div>
            <div class="block_3 flex-row justify-between">
              <div class="box_6 flex-col">
                <div class="group_3 flex-row">
                  <div class="group_4 flex-row">
                    <span class="text_59">2024</span>
                    <img
                        class="thumbnail_1"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/82327a4316ce9c2c2744f8cca8c0e08f"
                    />
                  </div>
                </div>
                <div class="group_5 flex-row justify-end">
                  <div class="block_4 flex-col justify-between">
                    <div class="text-wrapper_3 flex-col">
                      <span class="text_60">全省各级工商联组织数</span>
                    </div>
                    <div class="text-wrapper_4 flex-row justify-between">
                      <span class="text_61">150</span>
                      <span class="text_62">个</span>
                    </div>
                  </div>
                  <div class="block_5 flex-col justify-between">
                    <div class="text-wrapper_5 flex-col">
                      <span class="text_63">全省工商联会员总数</span>
                    </div>
                    <div class="text-wrapper_6 flex-row justify-between">
                      <span class="text_64">520461</span>
                      <span class="text_65">个</span>
                    </div>
                  </div>
                  <img
                      class="image_1"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/66c7108616b4c75d6069435fa6006f1d"
                  />
                  <img
                      class="image_2"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/e1a2a7c721b44068c4988d660ced849a"
                  />
                </div>
                <div class="group_6 flex-row justify-end">
                  <div class="box_7 flex-col justify-between">
                    <img
                        class="image_3"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/55c38d968d7e74a40565ca864ba18285"
                    />
                    <div class="text-wrapper_7 flex-row justify-between">
                      <span class="text_66">22</span>
                      <span class="text_67">名</span>
                    </div>
                  </div>
                  <span class="text_68">全省地级以上市平均工作人员</span>
                  <div class="box_8 flex-col justify-between">
                    <img
                        class="image_4"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/7e0f83689e3a79fa45e1b91b227ef53a"
                    />
                    <div class="text-wrapper_8 flex-row justify-between">
                      <span class="text_69">17</span>
                      <span class="text_70">名</span>
                    </div>
                  </div>
                  <span class="text_71">全省地级以上市编制人数</span>
                  <img
                      class="image_5"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/6007d74e31364e832b7f2175c7247f4c"
                  />
                  <img
                      class="image_6"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/6a9ad5b82db1806023dc277abd64c229"
                  />
                </div>
                <div class="group_7 flex-row justify-end">
                  <div class="group_8 flex-col justify-between">
                    <div class="text-wrapper_9 flex-col">
                      <span class="text_72">“五好”县级工商联数</span>
                    </div>
                    <div class="text-wrapper_10 flex-row">
                      <span class="text_73">全国</span>
                      <span class="text_74">110</span>
                      <span class="text_75">个</span>
                      <span class="text_76">全省</span>
                    </div>
                  </div>
                  <span class="text_77">121</span>
                  <span class="text_78">个</span>
                  <div class="group_9 flex-col justify-between">
                    <div class="text-wrapper_11 flex-col">
                      <span class="text_79"
                      >全省乡镇&nbsp;(街道)&nbsp;商会数</span
                      >
                    </div>
                    <div class="text-wrapper_12 flex-row justify-between">
                      <span class="text_80">1079</span>
                      <span class="text_81">个</span>
                    </div>
                  </div>
                  <img
                      class="image_7"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/cc0e2524507230940990125f02239e2e"
                  />
                  <img
                      class="image_8"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/7d8d5b14d1052863a5e547d8fcf4ad25"
                  />
                </div>
              </div>
              <div class="box_9 flex-col">
                <div class="box_10 flex-row justify-between">
                  <div class="section_2 flex-row">
                    <span class="text_82">广东省</span>
                    <img
                        class="thumbnail_2"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/3950c60b95f6fabe3dfcf08f0e5fc0e2"
                    />
                  </div>
                  <div class="section_3 flex-row">
                    <span class="text_83">政治面貌占比</span>
                    <img
                        class="thumbnail_3"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/77ec98b9444cb2ed1b277f4295ddc326"
                    />
                  </div>
                </div>
                <div class="text-wrapper_13 flex-row justify-between">
                  <span class="text_84">无党派人士</span>
                  <span class="text_85">49%</span>
                </div>
                <div class="text-wrapper_14 flex-row justify-between">
                  <span class="text_86">中共党员</span>
                  <span class="text_87">31%</span>
                </div>
                <div class="text-wrapper_15 flex-row justify-between">
                  <span class="text_88">群众</span>
                  <span class="text_89">13%</span>
                </div>
                <div class="text-wrapper_16 flex-row justify-between">
                  <span class="text_90">民主党派</span>
                  <span class="text_91">7%</span>
                </div>
                <div class="text-wrapper_17 flex-row justify-between">
                  <span class="text_92">共青团员</span>
                  <span class="text_93">0%</span>
                </div>
                <div class="box_11 flex-col">
                  <div class="section_4 flex-col"></div>
                  <div class="section_5 flex-col"></div>
                  <div class="section_6 flex-col"></div>
                  <div class="section_7 flex-col"></div>
                  <div class="section_8 flex-col"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="group_10 flex-col">
            <div class="box_12 flex-row">
              <div class="block_6 flex-col">
                <div class="image-wrapper_1 flex-col">
                  <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/63add2ec62a769bd988ff30f8f7d8971"
                  />
                </div>
                <span class="text_94">基础信息</span>
              </div>
              <div class="block_7 flex-row">
                <span class="text_95">执常委</span>
                <img
                    class="thumbnail_5"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/3185f6e1e81cd4cf243c98b6ad10ec8b"
                />
              </div>
              <div class="block_8 flex-col justify-between">
                <div class="group_11 flex-row justify-between">
                  <img
                      class="thumbnail_6"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/02aff6b5edd8e22f92a2b6ac3751ecdf"
                  />
                  <span class="text_96">请输入执常委姓名</span>
                </div>
                <div class="group_12 flex-col"></div>
              </div>
              <div class="block_9 flex-col justify-between">
                <div class="block_10 flex-row justify-between">
                  <img
                      class="label_4"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/a94f497ff71ede46beb47662ba87d621"
                  />
                  <span class="text_97">企业荣誉</span>
                </div>
                <img
                    class="image_9"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/641039543b39371faea1d307e10fdcad"
                />
              </div>
            </div>
            <div class="box_13 flex-row">
              <div class="group_13 flex-col">
                <div class="block_11 flex-col">
                  <div class="group_14 flex-row">
                    <div class="box_14 flex-col"></div>
                    <div class="text-wrapper_18 flex-col justify-between">
                      <span class="text_98">姓名:</span>
                      <span class="text_99">性别:</span>
                    </div>
                    <div class="text-wrapper_19 flex-col">
                      <span class="text_100">详情&gt;</span>
                      <span class="text_101">陈志列</span>
                      <span class="text_102">男</span>
                    </div>
                  </div>
                  <div class="text-wrapper_20 flex-row">
                    <span class="text_103">年龄:</span>
                    <span class="text_104">62岁</span>
                    <span class="text_105">学历:</span>
                    <span class="text_106">研究生</span>
                  </div>
                  <div class="text-wrapper_21 flex-row">
                    <span class="text_107">性别:</span>
                    <span class="text_108">男</span>
                    <span class="text_109">工商联职务:</span>
                    <span class="text_110">主席</span>
                  </div>
                </div>
                <div class="image-wrapper_2 flex-col">
                  <img
                      class="image_10"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/2564c68afcd591de0c9bb8dbf5783270"
                  />
                </div>
                <div class="block_12 flex-col">
                  <span class="text_111">详情&gt;</span>
                  <span class="text_112">企业名称</span>
                  <span class="text_113">研祥高科技控股集团有限公司</span>
                  <span class="text_114">法人代表</span>
                  <span class="text_115">陈志列</span>
                  <span class="text_116">行业代码</span>
                  <span class="text_117">信息传输、软件和信息技术服务业</span>
                  <div class="text-group_1 flex-col justify-between">
                    <span class="text_118">企业健康监测</span>
                    <span class="text_119">健康</span>
                  </div>
                </div>
                <span class="text_120">关联企业</span>
              </div>
              <div class="group_15 flex-col">
                <div class="box_15 flex-col">
                  <span class="text_121">参加中国光彩事业西藏行</span>
                  <div class="image-wrapper_3 flex-col">
                    <img
                        class="image_11"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/c3c957ce5d1a22c9822576d8f56e2dcb"
                    />
                  </div>
                </div>
                <div class="box_16 flex-col">
                  <div class="text-wrapper_22 flex-col">
                    <span class="text_122">向深圳市慈善会捐款50万元支持</span>
                    <span class="text_123">开展乡村产业振兴</span>
                  </div>
                  <div class="text-wrapper_23 flex-col">
                    <span class="text_124">参加中国光彩事业西藏行</span>
                  </div>
                  <div class="image-wrapper_4 flex-col">
                    <img
                        class="image_12"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/8413b6c51f0fc0765742aa2744604ea8"
                    />
                  </div>
                  <div class="image-wrapper_5 flex-col">
                    <img
                        class="image_13"
                        referrerpolicy="no-referrer"
                        src="https://lanhu-oss-2537-2.lanhuapp.com/59c304eafcb81479f80338fd14435952"
                    />
                  </div>
                </div>
                <div class="image-wrapper_6 flex-row justify-between">
                  <img
                      class="image_14"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/4f20e77faa28077cd5076d53bece7469"
                  />
                  <img
                      class="image_15"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/19ed92c01b93f2d882d494168fb3d7ac"
                  />
                </div>
                <div class="box_17 flex-row justify-between">
                  <div class="box_18 flex-col">
                    <div class="box_19 flex-col">
                      <div class="box_20 flex-row justify-between">
                        <div class="section_9 flex-col"></div>
                        <div class="section_10 flex-col"></div>
                        <div class="section_11 flex-col"></div>
                      </div>
                      <div class="text-wrapper_24 flex-row">
                        <span class="text_125">企业家全国人大代表</span>
                      </div>
                    </div>
                    <div class="box_21 flex-col">
                      <div class="section_12 flex-row justify-between">
                        <div class="group_16 flex-col"></div>
                        <div class="group_17 flex-col"></div>
                        <div class="group_18 flex-col"></div>
                      </div>
                      <div class="text-wrapper_25 flex-row">
                        <span class="text_126">广东省工商联主席</span>
                      </div>
                    </div>
                    <div class="box_22 flex-col">
                      <div class="group_19 flex-row justify-between">
                        <div class="section_13 flex-col"></div>
                        <div class="section_14 flex-col"></div>
                        <div class="section_15 flex-col"></div>
                      </div>
                      <div class="text-wrapper_26 flex-row">
                        <span class="text_127">广东省总商会会长</span>
                      </div>
                    </div>
                    <div class="box_23 flex-col">
                      <div class="group_20 flex-row justify-between">
                        <div class="section_16 flex-col"></div>
                        <div class="section_17 flex-col"></div>
                        <div class="section_18 flex-col"></div>
                      </div>
                      <div class="text-wrapper_27 flex-row">
                        <span class="text_128">全国工商联科技装备商会会长</span>
                      </div>
                    </div>
                  </div>
                  <div class="box_24 flex-col">
                    <div class="box_25 flex-col">
                      <div class="section_19 flex-row justify-between">
                        <div class="box_26 flex-col"></div>
                        <div class="box_27 flex-col"></div>
                        <div class="box_28 flex-col"></div>
                      </div>
                      <div class="text-wrapper_28 flex-row">
                        <span class="paragraph_2"
                        >提交题为关于加快推进国产操作系统<br />在工业领域适配建议</span
                        >
                      </div>
                    </div>
                    <div class="box_29 flex-col">
                      <div class="box_30 flex-row justify-between">
                        <div class="block_13 flex-col"></div>
                        <div class="block_14 flex-col"></div>
                        <div class="block_15 flex-col"></div>
                      </div>
                      <div class="text-wrapper_29 flex-row">
                        <span class="text_129"
                        >全国政协经济委专题座谈会上发言</span
                        >
                      </div>
                    </div>
                    <div class="box_31 flex-col">
                      <div class="section_20 flex-row justify-between">
                        <div class="group_21 flex-col"></div>
                        <div class="group_22 flex-col"></div>
                        <div class="group_23 flex-col"></div>
                      </div>
                      <div class="text-wrapper_30 flex-row">
                        <span class="text_130"
                        >参加最高法会议、调研活动5次</span
                        >
                      </div>
                    </div>
                    <div class="box_32 flex-col">
                      <div class="group_24 flex-row justify-between">
                        <div class="box_33 flex-col"></div>
                        <div class="box_34 flex-col"></div>
                        <div class="box_35 flex-col"></div>
                      </div>
                      <div class="text-wrapper_31 flex-row">
                        <span class="text_131"
                        >在最高法专题座谈会上发言4次</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box_36 flex-row">
                  <img
                      class="label_5"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/ef3db2c06b8ecea96f15a54da38519b9"
                  />
                  <span class="text_132">社会职务</span>
                  <img
                      class="label_6"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/b5f14d13c38659bd928d7fef554a9d9d"
                  />
                  <span class="text_133">参政议政</span>
                </div>
              </div>
              <div class="group_25 flex-col">
                <div class="box_37 flex-col">
                  <span class="text_134">中国企业500强</span>
                  <img
                      class="image_16"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/09cecd9f5facdb3082944bd0265b1419"
                  />
                  <img
                      class="image_17"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/82b246897e299a246e521065acaeefa4"
                  />
                </div>
                <div class="box_38 flex-col">
                  <span class="text_135">中国制造企业500强</span>
                  <img
                      class="image_18"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/b47012e77a73ccca6555251dbcc04e31"
                  />
                  <img
                      class="image_19"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/0478e4c60399c42411dd598a592b5261"
                  />
                </div>
                <div class="box_39 flex-col">
                  <span class="paragraph_3"
                  >2023-2025年制造业单项<br />冠军示范企业</span
                  >
                  <img
                      class="image_20"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/f79a6bbbf312b757e7a2e1591b4a958b"
                  />
                  <img
                      class="image_21"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/315d42fa1beb31e6dcb0959b58877d6b"
                  />
                </div>
                <div class="box_40 flex-col">
                  <span class="paragraph_4"
                  >2023-2026全国工商联<br />科技创新民营企业</span
                  >
                  <img
                      class="image_22"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/adaa7144932838878529ffbd9343181c"
                  />
                  <img
                      class="image_23"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/fb9a84ceea41feb85aaa26c20427c7f4"
                  />
                </div>
                <div class="box_41 flex-col">
                  <span class="paragraph_5"
                  >2022年度中国民营<br />企业信用100强</span
                  >
                  <img
                      class="image_24"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/cdd3fabd3571965e2531dd62adbdfcd4"
                  />
                  <img
                      class="image_25"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/3debc0fc46395d7dc751f31da834d63b"
                  />
                </div>
                <div class="box_42 flex-col">
                  <span class="paragraph_6"
                  >2022年度中国民营制造<br />企业信用100强</span
                  >
                  <img
                      class="image_26"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/30ccde39c3feeb1d31706f76eb6f6479"
                  />
                  <img
                      class="image_27"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/90a8464f7b3ccdbdfa077ecd64f1b4c3"
                  />
                </div>
                <div class="box_43 flex-col">
                  <span class="paragraph_7"
                  >中国战略性新兴产业领军<br />企业100强</span
                  >
                  <img
                      class="image_28"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/49e8684fdfcfb81c0d6e96334a150942"
                  />
                  <img
                      class="image_29"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/19aad8bf56d744d1000ee3df4e6f72da"
                  />
                </div>
                <div class="box_44 flex-col">
                  <span class="text_136">中国大企业创新100强</span>
                  <img
                      class="image_30"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/ccc58ccfca12a82a8ad1c5ba55712b67"
                  />
                  <img
                      class="image_31"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/301cd6d25b66b3b912d4b069cebd383c"
                  />
                </div>
                <div class="box_45 flex-col">
                  <span class="paragraph_8"
                  >2023年度优秀（政协）<br />委员工作站</span
                  >
                  <img
                      class="image_32"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/5a6d259b99f5b0a54c7384c2fcbcc706"
                  />
                  <img
                      class="image_33"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/ab45722a113594f15255c2a5d40159a9"
                  />
                </div>
                <div class="box_46 flex-col">
                  <span class="text_137">全国质量诚信先进企业</span>
                  <img
                      class="image_34"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/ebd57ce2171c88c552f2521de7f56dd9"
                  />
                  <img
                      class="image_35"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/9347ddc05dc4cce82ca115e70fba576d"
                  />
                </div>
              </div>
            </div>
            <div class="box_47 flex-col">
              <span class="text_138">向北京丘成桐科学基金会</span>
              <span class="text_139">开展乡村产业振兴</span>
              <div class="text-wrapper_32 flex-col">
                <span class="text_140">向深圳市慈善会捐款50万元支持</span>
                <span class="text_141">开展乡村产业振兴</span>
              </div>
            </div>
            <div class="text-wrapper_33 flex-col">
              <span class="text_142">广西壮族自治区马山县实地</span>
              <span class="text_143">走访调研2次</span>
            </div>
            <div class="text-wrapper_34 flex-col">
              <span class="text_144">广西壮族自治区马山县实地</span>
              <span class="text_145">走访调研2次</span>
            </div>
            <div class="text-wrapper_35 flex-col">
              <span class="text_146">支持农村春节疫情防控购买</span>
              <span class="text_147">制氧机捐款500万</span>
            </div>
          </div>
          <div class="group_26 flex-col justify-between">
            <div class="group_27 flex-col">
              <div class="block_16 flex-row">
                <span class="text_148">单位：个</span>
                <div class="box_48 flex-col"></div>
                <span class="text_149">会员总数</span>
                <div class="box_49 flex-col"></div>
                <span class="text_150">会员入库数</span>
                <div class="box_50 flex-row">
                  <span class="text_151">2024</span>
                  <img
                      class="thumbnail_7"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/1345271fefacf006d5b577d77b77f6ef"
                  />
                </div>
              </div>
              <div class="block_17 flex-row justify-between">
                <span class="paragraph_9"
                >100000<br />90000<br />80000<br />70000<br />60000<br />50000<br />40000<br />30000<br />20000<br />10000<br />0</span
                >
                <div class="group_28 flex-col">
                  <img
                      class="image_36"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/4a88549013ef37e7c9e29dc4b179c5d5"
                  />
                  <img
                      class="image_37"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/9b9ced94657193c31aea913f79834f49"
                  />
                  <img
                      class="image_38"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/4f0db3360ccc7e3696519b2a99ed08ce"
                  />
                  <img
                      class="image_39"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/d73354469f3b6cce895d5a792be3b1a3"
                  />
                  <img
                      class="image_40"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/97e5cba6bf962acb6293f4765fe73a39"
                  />
                  <img
                      class="image_41"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/a7cf9757660943b8769048d1b716c15c"
                  />
                  <img
                      class="image_42"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/5cd43131ef7acea45eb42a2e67cd53c5"
                  />
                  <img
                      class="image_43"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/c8f2ca483918dcc3354e5ca777ba6958"
                  />
                  <img
                      class="image_44"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/940c21b267232c0f6700631907bbd9ca"
                  />
                  <div class="block_18 flex-col">
                    <div class="section_21 flex-col"></div>
                  </div>
                  <div class="block_19 flex-col">
                    <div class="group_29 flex-col"></div>
                    <div class="group_30 flex-col"></div>
                    <div class="group_31 flex-col"></div>
                    <div class="group_32 flex-col"></div>
                    <div class="group_33 flex-col"></div>
                    <div class="group_34 flex-col"></div>
                  </div>
                </div>
              </div>
              <span class="text_152"
              >深圳&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;佛山&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;东莞&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;茂名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中山&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;韶关&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;肇庆&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;珠海&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;湛江</span
              >
              <div class="block_20 flex-col"></div>
              <div class="block_21 flex-col"></div>
              <div class="block_22 flex-col"></div>
              <div class="block_23 flex-col"></div>
              <div class="block_24 flex-col"></div>
              <div class="block_25 flex-col"></div>
              <div class="block_26 flex-col"></div>
              <div class="block_27 flex-col"></div>
              <div class="block_28 flex-col"></div>
              <div class="block_29 flex-col"></div>
              <div class="block_30 flex-col"></div>
              <div class="block_31 flex-col"></div>
              <div class="block_32 flex-col"></div>
              <div class="block_33 flex-col"></div>
              <div class="block_34 flex-col"></div>
              <div class="block_35 flex-col"></div>
              <div class="block_36 flex-col"></div>
            </div>
            <div class="group_35 flex-col">
              <div class="box_51 flex-row">
                <div class="group_36 flex-row">
                  <span class="text_153">2024</span>
                  <img
                      class="thumbnail_8"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/ae18e03a86f926ca6766310544933ce8"
                  />
                </div>
              </div>
              <div class="box_52 flex-row justify-end">
                <div class="group_37 flex-col">
                  <span class="text_154">省级会员</span>
                  <div class="text-wrapper_36 flex-row justify-between">
                    <span class="text_155">18.28</span>
                    <span class="text_156">%</span>
                  </div>
                  <span class="text_157">市级会员</span>
                  <div class="text-wrapper_37 flex-row justify-between">
                    <span class="text_158">41.76</span>
                    <span class="text_159">%</span>
                  </div>
                  <span class="text_160">县级会员</span>
                  <div class="text-wrapper_38 flex-row justify-between">
                    <span class="text_161">39.95</span>
                    <span class="text_162">%</span>
                  </div>
                </div>
                <div class="text-wrapper_39 flex-col justify-between">
                  <span class="text_163">95159</span>
                  <span class="text_164">217361</span>
                  <span class="text_165">207941</span>
                </div>
                <div class="text-wrapper_40 flex-col justify-between">
                  <span class="text_166">位</span>
                  <span class="text_167">位</span>
                  <span class="text_168">位</span>
                </div>
                <div class="group_38 flex-col">
                  <div class="box_53 flex-col"></div>
                  <div class="box_54 flex-col"></div>
                  <div class="box_55 flex-col"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="group_39 flex-col justify-between">
            <div class="group_40 flex-col">
              <div class="section_22 flex-row">
                <div class="block_37 flex-col"></div>
                <span class="text_169">市级商会数</span>
                <div class="block_38 flex-col"></div>
                <span class="text_170">区县商会数</span>
                <span class="text_171">*东莞市、中山市无区县级商会</span>
                <div class="block_39 flex-row">
                  <span class="text_172">2024</span>
                  <img
                      class="thumbnail_9"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/b366906e902e570e7000a3e50dbd8378"
                  />
                </div>
              </div>
              <img
                  class="image_45"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/915c76aad5095b1e466915af397a0847"
              />
            </div>
            <div class="group_41 flex-col">
              <div class="box_56 flex-row">
                <div class="block_40 flex-row">
                  <span class="text_173">2024</span>
                  <img
                      class="thumbnail_10"
                      referrerpolicy="no-referrer"
                      src="https://lanhu-oss-2537-2.lanhuapp.com/64c617317c139c737019ca436954c18b"
                  />
                </div>
              </div>
              <div class="box_57 flex-row">
                <img
                    class="image_46"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/a614f72f95a5e00aec4c332d32c34c94"
                />
                <div class="group_42 flex-col">
                  <div class="block_41 flex-col"></div>
                  <div class="block_42 flex-col"></div>
                  <div class="block_43 flex-col"></div>
                </div>
                <div class="text-wrapper_41 flex-col justify-between">
                  <span class="text_174">省工商联商会</span>
                  <span class="paragraph_10">地级以上市工商<br />联商会</span>
                  <span class="text_175">县级工商联商会</span>
                </div>
                <div class="text-wrapper_42 flex-col">
                  <span class="text_176">3.93</span>
                  <span class="text_177">39.20</span>
                  <span class="text_178">56.87</span>
                </div>
                <div class="text-wrapper_43 flex-col">
                  <span class="text_179">%</span>
                  <span class="text_180">%</span>
                  <span class="text_181">%</span>
                </div>
                <div class="group_43 flex-col justify-between">
                  <div class="text-wrapper_44">
                    <span class="text_182">(</span>
                    <span class="text_183">146</span>
                    <span class="text_184">)</span>
                  </div>
                  <div class="text-wrapper_45">
                    <span class="text_185">(</span>
                    <span class="text_186">1455</span>
                    <span class="text_187">)</span>
                  </div>
                  <div class="text-wrapper_46">
                    <span class="text_188">(</span>
                    <span class="text_189">2111</span>
                    <span class="text_190">)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block_44 flex-row">
          <div class="group_44 flex-col">
            <div class="group_45 flex-row">
              <div class="box_58 flex-col"></div>
              <span class="text_191">实际工作人员平均数</span>
              <div class="box_59 flex-col"></div>
              <span class="text_192">平均编制数</span>
              <div class="box_60 flex-row">
                <span class="text_193">2024</span>
                <img
                    class="thumbnail_11"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/d57960f2461c6234896271eedc5c2149"
                />
              </div>
            </div>
            <span class="text_194">单位：名</span>
            <div class="group_46 flex-row justify-between">
              <span class="paragraph_11"
              >16.00<br />14.00<br />12.00<br />10.00<br />8.00<br />6.00<br />4.00<br />2.00<br />0.00</span
              >
              <div class="image-wrapper_7 flex-col">
                <img
                    class="image_47"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/6c200b6e14c741551070af9fa27f1da6"
                />
                <img
                    class="image_48"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/a1a9fea183f60ff6e069c877566d266f"
                />
                <img
                    class="image_49"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/cfc96beab84986ac9113c84022cfbc09"
                />
                <img
                    class="image_50"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/61452c5a400183ea82d7059e9920554a"
                />
                <img
                    class="image_51"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/020797c0f5877af240a5d2d6b5287212"
                />
                <img
                    class="image_52"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/e2c40899fb018b5c195752761b88176b"
                />
                <img
                    class="image_53"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/541fa37dadeeaa746e80db02d4949d30"
                />
                <img
                    class="image_54"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/3672efe7f08c2c65b755ded144dacaf2"
                />
                <img
                    class="image_55"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/38fdaa44f9b4f577da09c7ec61b2a246"
                />
              </div>
            </div>
            <span class="text_195"
            >广州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深圳&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;珠海&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;佛山&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;肇庆&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;汕头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;汕尾&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;潮州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;揭阳&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阳江&nbsp;&nbsp;&nbsp;</span
            >
            <div class="group_47 flex-col"></div>
            <div class="group_48 flex-col"></div>
            <div class="group_49 flex-col"></div>
            <div class="group_50 flex-col"></div>
            <div class="group_51 flex-col"></div>
            <div class="group_52 flex-col"></div>
            <div class="group_53 flex-col"></div>
            <div class="group_54 flex-col"></div>
            <div class="group_55 flex-col"></div>
            <div class="group_56 flex-col"></div>
            <div class="group_57 flex-col"></div>
            <div class="group_58 flex-col"></div>
            <div class="group_59 flex-col"></div>
            <div class="group_60 flex-col"></div>
            <div class="group_61 flex-col"></div>
            <div class="group_62 flex-col"></div>
            <div class="group_63 flex-col"></div>
            <div class="group_64 flex-col"></div>
            <div class="group_65 flex-col"></div>
            <div class="group_66 flex-col"></div>
            <div class="group_67 flex-col"></div>
            <div class="group_68 flex-col"></div>
            <div class="group_69 flex-col"></div>
            <div class="group_70 flex-col"></div>
          </div>
          <div class="group_71 flex-col">
            <div class="group_72 flex-row justify-between">
              <div class="group_73 flex-row">
                <span class="text_196">2024</span>
                <img
                    class="thumbnail_12"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/7aeaeb4155724e97b8669b720a4a92cc"
                />
              </div>
              <div class="group_74 flex-row">
                <span class="text_197">企业家副主席</span>
                <img
                    class="thumbnail_13"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/c3b9697cb82e880e19b05656a63235cc"
                />
              </div>
            </div>
            <div class="group_75 flex-row">
              <div class="text-group_2 flex-col justify-between">
                <span class="text_198">63%</span>
                <span class="text_199">优秀</span>
              </div>
              <div class="text-group_3 flex-col justify-between">
                <span class="text_200">24%</span>
                <span class="text_201">良好</span>
              </div>
              <div class="text-group_4 flex-col justify-between">
                <span class="text_202">4%</span>
                <span class="text_203">称职</span>
              </div>
              <div class="text-group_5 flex-col justify-between">
                <span class="text_204">9%</span>
                <span class="text_205">不称职</span>
              </div>
            </div>
            <div class="image-wrapper_8 flex-row">
              <img
                  class="image_56"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/cf2618c5bc6d8a510687e55833f696db"
              />
              <img
                  class="image_57"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/621bb05a7b3cdcb91034773f115f5b27"
              />
              <img
                  class="image_58"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/2721c56ea655fec245ade35cb3bd3eba"
              />
              <img
                  class="image_59"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/dfd24ffc8300d38fd32b779f6370031e"
              />
            </div>
            <div class="group_76 flex-row">
              <div class="box_61 flex-col justify-between">
                <div class="block_45 flex-col"></div>
                <div class="block_46 flex-col"></div>
              </div>
              <div class="text-group_6 flex-col justify-between">
                <span class="text_206"
                >优秀&nbsp;(120分以上且排名在总人数前15%)</span
                >
                <span class="text_207"
                >良好&nbsp;(100分以上且排名未在总人数前15%)</span
                >
              </div>
              <div class="box_62 flex-col justify-between">
                <div class="group_77 flex-col"></div>
                <div class="group_78 flex-col"></div>
              </div>
              <div class="text-group_7 flex-col justify-between">
                <span class="text_208">称职&nbsp;(90-99分)</span>
                <span class="text_209">不称职&nbsp;(90分以下)</span>
              </div>
            </div>
          </div>
          <div class="group_79 flex-col">
            <div class="box_63 flex-row">
              <img
                  class="label_7"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/36ed188aa7831f2938ceafb8c909f908"
              />
              <img
                  class="image_60"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/ec03b6717aae92331929c15810f85123"
              />
              <div class="text-wrapper_47">
                <span class="text_210"
                >依托大数据动态监测，建立执常委企业健康预警机制，重点监测企业的“</span
                >
                <span class="text_211">经营异常、行政处罚、失信、吊销</span>
                <span class="paragraph_12"
                >”等风险点，有效保障执常委企业合<br />规稳健发展，已纳入监测的企业有</span
                >
                <span class="text_212">431</span>
                <span class="text_213">家，其中</span>
                <span class="text_214">2</span> <span class="text_215"></span>
                <span class="text_216">家企业存在风险预警：</span>
              </div>
            </div>
            <div class="text-wrapper_48 flex-row">
              <span class="text_217">预警类型</span>
              <span class="text_218">预警内容</span>
              <span class="text_219">数据更新时间</span>
              <span class="text_220">操作</span>
            </div>
            <div class="text-wrapper_49 flex-row">
              <span class="text_221">经营异常</span>
              <span class="paragraph_13"
              >未依照《企业信息公示暂行条例》第八<br />条规定的期限公示年度报告的</span
              >
              <span class="text_222">2024/10/18&nbsp;9:49:13</span>
              <span class="text_223">取消预警展示</span>
            </div>
            <div class="text-wrapper_50 flex-row">
              <span class="text_224">经营异常</span>
              <span class="text_225">通过登记的住所或者经营场所无法联系的</span>
              <span class="text_226">2023/3/17&nbsp;0:00:00</span>
              <span class="text_227">取消预警展示</span>
            </div>
            <div class="box_64 flex-col">
              <div class="text-wrapper_51 flex-row">
                <span class="text_228">执常委姓名</span>
                <span class="text_229">企业名称</span>
                <span class="text_230">社会代码</span>
                <span class="text_231">所属行业</span>
              </div>
              <div class="text-wrapper_52 flex-row">
                <span class="text_232">谢龙彬</span>
                <span class="paragraph_14">广东可亚贸易发展<br />有限公司</span>
                <span class="paragraph_15">91440904M<br />A55RRAEXD</span>
                <span class="text_233">批发和零售业</span>
              </div>
              <div class="text-wrapper_53 flex-row">
                <span class="text_234">马少挺</span>
                <span class="paragraph_16"
                >英德市永昌投资开<br />发有限公司<br /><br
                /></span>
                <span class="paragraph_17">914418816<br />71369140Q</span>
                <span class="text_235">房地产业</span>
              </div>
            </div>
          </div>
          <div class="group_80 flex-col">
            <div class="box_65 flex-row">
              <div class="box_66 flex-col"></div>
              <span class="text_236">商会总数</span>
              <div class="box_67 flex-col"></div>
              <span class="text_237">党组织数</span>
              <div class="box_68 flex-col"></div>
              <span class="text_238">党组织覆盖率</span>
              <div class="box_69 flex-row">
                <span class="text_239">2024</span>
                <img
                    class="thumbnail_14"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/719e4036035651a9a6e6ff052b715254"
                />
              </div>
            </div>
            <span class="text_240">单位：个</span>
            <div class="box_70 flex-row">
              <span class="paragraph_18"
              >900<br />800<br />700<br />600<br />500<br />400<br />300<br />200<br />100<br />0</span
              >
              <div class="box_71 flex-col">
                <img
                    class="image_61"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/f80456bb5deea0b950b6a283b4a49fc6"
                />
                <img
                    class="image_62"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/1a48a58827ef7201236f2953cb379d2b"
                />
                <img
                    class="image_63"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/0157a5cfd4fa79371e2604802fe43ca5"
                />
                <img
                    class="image_64"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/ae9edffc6b2cd7f5628092e59ece9c42"
                />
                <img
                    class="image_65"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/5e637e6d189e8e1e23fc09798cc2eebb"
                />
                <img
                    class="image_66"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/e8f4d20999fd58019b15be098a818ee8"
                />
                <img
                    class="image_67"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/c79b2623bb8a0d601771c1044c20fb10"
                />
                <img
                    class="image_68"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/fee5c1e78f7d5c1b04778531a2b55f61"
                />
                <div class="group_81 flex-col">
                  <div class="box_72 flex-col"></div>
                </div>
                <div class="group_82 flex-col">
                  <div class="box_73 flex-col"></div>
                  <div class="box_74 flex-col"></div>
                  <div class="box_75 flex-col"></div>
                  <div class="box_76 flex-col"></div>
                </div>
              </div>
              <span class="paragraph_19"
              >90.00%<br />80.00%<br />70.00%<br />60.00%<br />50.00%<br />40.00%<br />30.00%<br />20.00%<br />10.00%<br />0.00%</span
              >
            </div>
            <span class="text_241"
            >深圳&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中山&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;清远&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;珠海&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;佛山&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;东莞&nbsp;&nbsp;&nbsp;&nbsp;肇庆&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;湛江&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
            <div class="box_77 flex-col"></div>
            <div class="box_78 flex-col"></div>
            <div class="box_79 flex-col"></div>
            <div class="box_80 flex-col"></div>
            <div class="box_81 flex-col"></div>
            <div class="box_82 flex-col"></div>
            <div class="box_83 flex-col"></div>
            <div class="box_84 flex-col"></div>
            <div class="box_85 flex-col"></div>
            <div class="box_86 flex-col"></div>
            <div class="box_87 flex-col"></div>
            <div class="box_88 flex-col"></div>
            <div class="box_89 flex-col"></div>
            <div class="box_90 flex-col"></div>
            <div class="box_91 flex-col"></div>
            <div class="box_92 flex-col"></div>
            <div class="box_93 flex-col"></div>
            <img
                class="image_69"
                referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/4c4cfc184f616b4d674ab2015cffd692"
            />
          </div>
          <div class="group_83 flex-col">
            <div class="block_47 flex-row">
              <div class="group_84 flex-row">
                <span class="text_242">2024</span>
                <img
                    class="thumbnail_15"
                    referrerpolicy="no-referrer"
                    src="https://lanhu-oss-2537-2.lanhuapp.com/6862d53c767d17bd082d8053603e8df3"
                />
              </div>
            </div>
            <div class="block_48 flex-row">
              <img
                  class="image_70"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/cc77f0f4af065ec64e1d311c00a7381c"
              />
              <div class="group_85 flex-col">
                <div class="block_49 flex-col"></div>
                <div class="block_50 flex-col"></div>
                <div class="block_51 flex-col"></div>
                <div class="block_52 flex-col"></div>
                <div class="block_53 flex-col"></div>
              </div>
              <div class="text-wrapper_54 flex-col">
                <span class="text_243">行业商会</span>
                <span class="text_244">镇街商会</span>
                <span class="text_245">异地商会</span>
                <span class="text_246">综合商会</span>
                <span class="text_247">园区/市场商会</span>
              </div>
              <div class="text-wrapper_55 flex-col">
                <span class="text_248">1246</span>
                <span class="text_249">1079</span>
                <span class="text_250">927</span>
                <span class="text_251">441</span>
                <span class="text_252">19</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-wrapper_56 flex-col">
          <div class="card-title"><div>全省工商联发展情况</div></div>
        </div>
        <div class="text-wrapper_57 flex-col">
          <div class="card-title"><div>执常委画像</div></div>
        </div>
        <div class="block_54 flex-col">
          <div class="block_55 flex-col">
            <div class="section_23 flex-col">
              <div class="group_86 flex-col"></div>
            </div>
            <div class="section_24 flex-row">
              <span class="text_255">各地级以上市工商联会员入库情况分析</span>
              <img
                  class="image_71"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/c2098b5fc3c5ff25c5fb620b7ca49b27"
              />
              <img
                  class="image_72"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/4ac1c8d38232f01c4a64ab480923347c"
              />
              <img
                  class="thumbnail_16"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/1090cda8d5dd4a10e0614be8e088f694"
              />
            </div>
          </div>
        </div>
        <div class="block_56 flex-col">
          <div class="section_25 flex-col">
            <div class="box_94 flex-col">
              <div class="box_95 flex-col"></div>
            </div>
            <div class="box_96 flex-row">
              <span class="text_256">全省工商联商会党组织成立情况</span>
              <img
                  class="image_73"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/c1f4ba17cc2c238a3bca87c959ba6714"
              />
              <img
                  class="image_74"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/6a8a51d0e3b95dbd4fc2e792cd745489"
              />
              <img
                  class="thumbnail_17"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/1899baeab75492c43ff8087eb0b50244"
              />
            </div>
          </div>
        </div>
        <div class="block_57 flex-col">
          <div class="group_87 flex-col">
            <div class="box_97 flex-col">
              <div class="group_88 flex-col"></div>
            </div>
            <div class="box_98 flex-row">
              <span class="text_257">全省工商联商会数量情况分析</span>
              <img
                  class="image_75"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/d35aa96a0c5ff7b6f1efbb8efddad78e"
              />
              <img
                  class="image_76"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/71b9fe31f1d08ae5c7c81341726d559d"
              />
              <img
                  class="thumbnail_18"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/4473948d97170eb67bef0e0da069445b"
              />
            </div>
          </div>
        </div>
        <div class="block_58 flex-col">
          <div class="box_99 flex-col">
            <div class="box_100 flex-col">
              <div class="group_89 flex-col"></div>
            </div>
            <div class="box_101 flex-row">
              <span class="text_258">工商联执常委分析统计</span>
              <img
                  class="image_77"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/fd3ab8b49b8773bf848beaf4966f2239"
              />
              <img
                  class="image_78"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/bf9c145f1760260302f7370c0863199f"
              />
              <img
                  class="thumbnail_19"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/08c5d17fde6ba485c869ae725e6b92bb"
              />
            </div>
          </div>
        </div>
        <div class="block_59 flex-col">
          <div class="box_102 flex-col">
            <div class="box_103 flex-col">
              <div class="group_90 flex-col"></div>
            </div>
            <div class="box_104 flex-row">
              <span class="text_259">工商联执常委履职评价情况</span>
              <img
                  class="image_79"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/970df0ead9595866fdc4c16df8dff5b3"
              />
              <img
                  class="image_80"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/8e7c7d0e130537a68035bc2166345da0"
              />
              <img
                  class="thumbnail_20"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/06a9d59fcb35e34d54cf9eeebcf8971b"
              />
            </div>
          </div>
        </div>
        <div class="block_60 flex-col">
          <div class="box_105 flex-col">
            <div class="block_61 flex-col">
              <div class="group_91 flex-col"></div>
            </div>
            <div class="block_62 flex-row">
              <span class="text_260">全省工商联商会类型情况分析</span>
              <img
                  class="image_81"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/b4edaff398699415fd670b68be58cbf9"
              />
              <img
                  class="image_82"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/b974f875aaa169fdeb9a2cbb4c2af479"
              />
              <img
                  class="thumbnail_21"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/ff4b917c9b1d8b63086959cb9d1d3d53"
              />
            </div>
          </div>
        </div>
        <div class="block_63 flex-col">
          <div class="group_92 flex-col">
            <div class="group_93 flex-col">
              <div class="group_94 flex-col"></div>
            </div>
            <div class="group_95 flex-row">
              <span class="text_261">工商联各级会员占比情况</span>
              <img
                  class="image_83"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/e477ee7caf4705537101afeadb239ad5"
              />
              <img
                  class="image_84"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/260ccd0ed9640fcfe9b6b06a7566bed3"
              />
              <img
                  class="thumbnail_22"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/cb164cb36cc16087239fcccd358c3549"
              />
            </div>
          </div>
        </div>
        <div class="text-wrapper_58 flex-col">
          <span class="text_262">工商联执常委企业健康监测</span>
        </div>
        <div class="block_64 flex-col">
          <div class="section_26 flex-col">
            <div class="block_65 flex-col">
              <div class="group_96 flex-col"></div>
            </div>
            <div class="block_66 flex-row">
              <span class="text_263">全省工商联商会层级情况分析</span>
              <img
                  class="image_85"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/7c31988ba45eed233b7f8428be8f3bd4"
              />
              <img
                  class="image_86"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/adc20d80fa51208236cec612b03df325"
              />
              <img
                  class="thumbnail_23"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/78ff92b2661f4ea2103c619da3940ca1"
              />
            </div>
          </div>
        </div>
        <div class="block_67 flex-col">
          <div class="section_27 flex-col">
            <div class="box_106 flex-col">
              <div class="box_107 flex-col"></div>
            </div>
            <div class="box_108 flex-row">
              <span class="text_264">全省工商联工作人员情况</span>
              <img
                  class="image_87"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/2c8ea75888304cd0ecf5c166dda00266"
              />
              <img
                  class="image_88"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/cf8abfc0244ed3ee217f9de7c05cbef5"
              />
              <img
                  class="thumbnail_24"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/ac311e097f30c38d0bf97bf31aea7737"
              />
            </div>
          </div>
        </div>
        <div class="block_68 flex-col">
          <div class="section_28 flex-col">
            <div class="box_109 flex-col">
              <div class="section_29 flex-col"></div>
            </div>
            <div class="box_110 flex-row">
              <span class="text_265">广东省工商联组织概况</span>
              <img
                  class="image_89"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/d9bb9f2333fae2a49b8561259e01887f"
              />
              <img
                  class="image_90"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/1e880736fd55c630605573f0c9d08f2a"
              />
              <img
                  class="thumbnail_25"
                  referrerpolicy="no-referrer"
                  src="https://lanhu-oss-2537-2.lanhuapp.com/25efe64992814e45220044434af477d9"
              />
            </div>
          </div>
        </div>
        <img
            class="image_91"
            referrerpolicy="no-referrer"
            src="https://lanhu-oss-2537-2.lanhuapp.com/7af3261658b1e624ad8c6acd4d02eefb"
        />
        <img
            class="image_92"
            referrerpolicy="no-referrer"
            src="https://lanhu-oss-2537-2.lanhuapp.com/0d6ffe9b8a07c0449456b483e0d18d57"
        />
        <img
            class="image_93"
            referrerpolicy="no-referrer"
            src="https://lanhu-oss-2537-2.lanhuapp.com/572d1522a18a73109a38af6c0e6bbf14"
        />
      </div>
    </div>
<!--    <EleDialog :title="dialogTitle" :visible.sync="showDialog">-->
<!--      <div class="filter-box" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">-->
<!--        <ElementSelect-->
<!--            :val="search.cityName"-->
<!--            :options="optionCity"-->
<!--            clearable-->
<!--            @val="changeVal($event, 'cityName')"-->
<!--            v-if="!apiName.includes('City')"-->
<!--            size="middle"-->
<!--        />-->
<!--        <ElementSelect-->
<!--            :val="search.year"-->
<!--            :options="optionYear"-->
<!--            clearable-->
<!--            @val="changeVal($event, 'year')"-->
<!--            v-else-->
<!--            size="middle"-->
<!--        />-->
<!--        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" />-->
<!--      </div>-->
<!--      <ComTable-->
<!--          :tableCol="tableCol"-->
<!--          :tableData="tableData"-->
<!--          :pager="pager"-->
<!--          @handleSizeChange="handleSizeChange"-->
<!--          @handleCurrentChange="handleCurrentChange"-->
<!--      />-->
<!--    </EleDialog>-->

    <!--<div class="loading" v-loading="loading" v-if="loading"-->
    <!--     element-loading-background="rgba(0, 0, 0, 0)">-->
    <!--</div>-->
    <div class="o0"></div>
  </div>
</template>

<script>
import { getTime } from '@/utils';
import router from '@/router';
import GzMap from './comp/GzMap';
import TopCountMarket from './comp/TopCountMarket';
import EconomicEntities from './comp/EconomicEntities';
import PrivateEnterprise from './comp/PrivateEnterprise';
import Top500 from './comp/Top500';
import CompanyTop100 from './comp/CompanyTop100';
import ChartBar from './comp/ChartBar';
import ChartBarPlus from './comp/ChartBarPlus.vue';
import ChartMarketRight from './comp/ChartMarketRight.vue';
import GDPAndGrowthRate from './comp/GDP-and-growth-rate';
import FixedAssetInvestment from './comp/fixed-asset-investment';
import EconomicVolume from './comp/economic-volume';
import PrivateEconomy from './comp/PrivateEconomy.vue';
import FinancialService from './comp/FinancialService.vue';
import ScienceTenchnology from './comp/ScienceTenchnology.vue';
import Top100 from './comp/Top100';
import PrivateMigrate from './comp/PrivateMigrate.vue';
import MarketSubjectType from './comp/MarketSubjectType';
import MarketMainIndustry from './comp/MarketMainIndustry.vue';
import SmallMicroEnterprises from './comp/SmallMicroEnterprises.vue';
import Chart3D from './comp/Chart3D';
import ComTable from '../../components/ComTable';
import ElementSelect from '../../components/element-select';
import cityJson from './cityJson';
import MyHeader from '@/components/Header';
import MemberLeft from './comp/MemberLeft';
import MemberRight from './comp/MemberRight';
import MemberCenter from './comp/MemberCenter';

export default {
  name: 'Market',
  components: {
    MyHeader,
    ElementSelect,
    ComTable,
    Chart3D,
    ScienceTenchnology,
    Top100,
    PrivateMigrate,
    PrivateEconomy,
    FinancialService,
    MarketSubjectType,
    MarketMainIndustry,
    SmallMicroEnterprises,
    EconomicVolume,
    FixedAssetInvestment,
    GDPAndGrowthRate,
    ChartBar,
    ChartBarPlus,
    ChartMarketRight,
    CompanyTop100,
    Top500,
    PrivateEnterprise,
    EconomicEntities,
    TopCountMarket,
    GzMap,
    MemberLeft,
    MemberRight,
    MemberCenter
  },
  data() {
    return {
      linkParams: {
        dataType: 1,
        year: 2024,
      },
      isLogin: true,
      pass: '',
      // currentTime: getTime(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      timer: null,
      mapCode: 1,
      mapName: '',
      loading: false,
      showDialog: false,
      dialogTitle: '',
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: '',
        enterpriseName: '',
      },
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
      linkList: [
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
        {
          label: '广东省累计市场主体',
          value: 1,
        },
      ],
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    mapCode(n) {
      console.log(n, '-mapCode-n');
    },
    isLogin(n) {
      if (n) {
        // let expiredTime = sessionStorage.getItem('expiredTime'),
        //   nowStamp = new Date().getTime(),
        //   lessHour = expiredTime - nowStamp < 1000 * 60 * 60;
        // // if (lessHour) {
        //   setTimeout(() => {
        //     console.log(expiredTime - nowStamp, new Date(), expiredTime, nowStamp, '-in-expiredTime - nowStamp')
        //     this.$message.warning('登录超时，请重新登录！');
        //     sessionStorage.removeItem('expiredTime');
        //     this.isLogin = false;
        //   }, expiredTime - nowStamp)
        // // }
      }
    },
    // 'search.enterpriseName'(n) {
    //   this.getData();
    // },
  },
  mounted() {
    // this.timer =  setInterval(() => {
    //     this.currentTime = getTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
    //   }, 1000);
    this.busOn();
    this.setTimer();

    // let expiredTime = sessionStorage.getItem('expiredTime');
    // let nowStamp = new Date().getTime();
    // if (expiredTime && nowStamp < expiredTime) {
    //   this.isLogin = true;
    // }

    window.onresize = () => {
      this.resizeChart();
    };
  },
  methods: {
    handleLink(e) {
      console.log(e);
      this.linkParams = e;
    },
    clearSearch() {
      this.pager.pageSize = 10;
      this.pager.currentPage = 1;
      this.search = {
        enterpriseName: '',
        provinceName: '',
        cityName: '',
        year: '',
      };
    },
    // busOn() {
    //   this.$bus.$on('showEn500Dialog', (data) => {
    //     this.dialogTitle =
    //         data.name + `${data.name.includes('省') || data.name.length > 2 ? '' : '市'}全国民营企业500强名单`;
    //     this.clearSearch();
    //     let params = {
    //       cityName: data.name,
    //       year: data.year,
    //     };
    //     if (data.type === 1) {
    //       delete params.cityName;
    //       params.provinceName = data.name;
    //     }
    //     this.search = {
    //       ...this.search,
    //       ...params,
    //     };
    //     this.getData('500强', params);
    //   });
    // },
    // handleClickChart(params, name) {
    //   console.log(params, name, 'pp');
    //   this.dialogTitle = `${params.name}年${name}${params.seriesName}名单`;
    //   this.clearSearch();
    //   this.search.year = params.name;
    //   this.getData(name, this.search);
    //   this.show = true;
    // },
    // changeVal(e, type) {
    //   this.search[type] = e;
    //   this.getData();
    // },
    // handleSizeChange(e) {
    //   this.pager.pageSize = e;
    //   this.getData();
    // },
    // handleCurrentChange(e) {
    //   this.pager.currentPage = e;
    //   this.getData();
    // },
    changeMapCode(e) {
      this.mapCode = e.code;
      this.mapName = e?.name;
      console.log(e, '-e');
    },
    submit() {
      if (this.pass) {
        if (this.pass !== 'sgsl2022') {
          this.$message.info('密码错误，请重新输入！');
        } else {
          this.isLogin = true;
          let expiredTime = new Date().getTime() + 1000 * 60 * 60 * 12;
          sessionStorage.setItem('expiredTime', expiredTime);
        }
      } else {
        this.$message.info('请输入密码！');
      }
    },
    setTimer() {
      this.timer1 = setInterval(() => {
        this.$nextTick(() => {
          let chartBox = [
            'PrivateEnterprise',
            'barHighTech',
            'barSpecialNew',
            'GDPAndGrowthRate',
            'FixedAssetInvestment',
            'EconomicVolume',
            'MarketSubjectType',
            'MarketMainIndustry',
            'barPrivateTax',
            'barBankFinance',
          ];
          let i = 0;
          chartBox.map((item) => {
            setTimeout(() => {
              // this.$refs[item].setInterData();
            }, i * 100);
            i++;
          });
        });
      }, 5000);
    },
    resizeChart() {
      let chartBox = [
        'PrivateEnterprise',
        'barHighTech',
        'barSpecialNew',
        'GDPAndGrowthRate',
        'FixedAssetInvestment',
        'EconomicVolume',
        'MarketSubjectType',
        'MarketMainIndustry',
        'barPrivateTax',
        'barBankFinance',
      ];
      chartBox.map((item) => {
        for (let key in this.$refs[item].$refs) {
          this.$refs[item].$refs[key].resize();
        }
      });
    },
    // getData(name, params) {
    //   let apiName = this.apiName;
    //   !name ? (name = this.dialogTitle) : '';
    //   if (this.dialogTitle.includes('企业中小')) {
    //     apiName = 'getSpecialNewEnterpriseList';
    //   }
    //   if (this.dialogTitle.includes('企业小巨人')) {
    //     apiName = 'getLitterEnterpriseList';
    //   }
    //   if (this.dialogTitle.includes('500强')) {
    //     apiName = 'getMapCityEnList';
    //   }
    //   this.apiName = apiName;
    //   params = {
    //     ...params,
    //     ...this.search,
    //     pageSize: this.pager.pageSize,
    //     pageNum: this.pager.currentPage,
    //   };
    //   this.search = {
    //     ...params,
    //   };
    //   if (!apiName) return;
    //   this.$api.screen[apiName](params).then((res) => {
    //     let { data } = res.data;
    //     this.tableData = data.records;
    //     this.pager.total = data.total;
    //     this.showDialog = true;
    //     this.loading = false;
    //   });
    // },
    toPolicy() {
      router.push('/policy');
    },
  },
  beforeDestroy() {
    this.$bus.$off('showEn500Dialog');
    // sessionStorage.removeItem('expiredTime');
    // clearInterval(this.timer)
    // clearSetInterval(this.timer1)
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1080px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  .left-bar,
  .right-bar {
    width: 24px;
    height: 899px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: url('~img/market/market-left-bar.png') center center no-repeat;
    background-size: 100%;
  }
  .right-bar {
    left: unset;
    right: 0;
    transform: translateY(-50%) rotateY(180deg);
  }
  .bottom-bar {
    height: 24px;
    width: 2441px;
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 999;
    transform: translateX(-50%);
    background: url('~img/market/market-bottom-bar.png') center center no-repeat;
    background-size: 100%;
  }

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.content {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100% - 96px);
  z-index: 11;

  .center {
    flex: 1;
    position: relative;
    z-index: 1;

    .link {
      position: absolute;
      left: 38px;
      top: 208px;
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      text-decoration: underline;
      color: #e9e3b6;
      line-height: 43px;
      font-weight: bold;
      text-shadow: 2px 3px 2px rgba(30, 40, 60, 0.8);
      z-index: 2;
      cursor: pointer;
    }
    .aMap {
      width: calc(100% - 64px);
      position: absolute;
      top: 0;
      left: 32px;
      /*top: 250px;*/
    }

    /*width: 59%;*/
    //  border:1px solid #333;
  }

  .left,
  .right {
    display: flex;
    // z-index: 2;
    flex-wrap: wrap;
    // width: 20%;
    // border:1px solid #333;

    > div:first-child {
      // margin-right: 30px;
    }
  }

  .left {
    // width: 31%;
    width: 1024px;
    padding-left: 32px;
  }

  .right {
    width: 1024px;
    padding-right: 32px;
    > div {
      width: 100%;
      height: calc(100% / 3);
    }
    .right-center {
      display: flex;
      > div {
        width: calc(50% - 13px);
        &:first-of-type {
          margin-right: 26px;
        }
        /deep/ .title {
          white-space: nowrap;
          width: 100%;
          #btn-link {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        /deep/ .flex-between {
          height: 52px;
        }
      }
    }
  }
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  /*filter: blur(10px);*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.o0 {
  opacity: 0;
  width: 100px;
  height: 100px;
  background: url('~img/commonImg/map_bg.jpg');
}










// 原型设计


.box_3 {
  position: relative;
  width: 3200px;
  height: 976px;
  margin-bottom: 1px;
}
.block_1 {
  width: 3135px;
  height: 580px;
  margin: 31px 0 0 32px;
}
-group_1 {
  width: 88px;
  height: 32px;
  margin: 13px 0 24px 13px;
}
.block_2 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  width: 1022px;
  height: 250px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-left: 1px;
}
.box_4 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(61, 164, 255, 0.109804) 53.735352%,
      rgba(61, 164, 255, 1) 93.115234%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.501961) 100%
  );
  border-radius: 3px;
  width: 639px;
  height: 26px;
  margin: 16px 0 0 14px;
}
.text_3 {
  width: 154px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 6px 0 0 27px;
}
-group_2 {
  width: 27px;
  height: 27px;
}
.text_4 {
  width: 126px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 6px 0 0 43px;
}
.box_5 {
  background-color: rgba(86, 128, 202, 1);
  width: 1px;
  height: 17px;
  margin: 5px 0 0 43px;
}
.text_5 {
  width: 154px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 6px 29px 0 29px;
}
.text-wrapper_2 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
  margin: 14px 0 20px 11px;
}
.text_6 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_7 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_8 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_9 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_10 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_11 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_12 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_13 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_14 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_15 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_16 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_17 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_18 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_19 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_20 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_21 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_22 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_23 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_24 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_25 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_26 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_27 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_28 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_29 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_30 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_31 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_32 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_33 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(241, 211, 83, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.paragraph_1 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_34 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_35 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_36 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_37 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_38 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_39 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_40 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_41 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_42 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_43 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_44 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_45 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_46 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_47 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_48 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_49 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_50 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_51 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(210, 186, 79, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_52 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_53 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_54 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_55 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_56 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_57 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 20px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.text_58 {
  width: 1012px;
  height: 174px;
  overflow-wrap: break-word;
  color: rgba(193, 236, 251, 1);
  font-size: 12px;
  font-family: DOUYU-Font;
  font-weight: normal;
  text-align: left;
  line-height: 26px;
}
.block_3 {
  width: 1023px;
  height: 281px;
  margin-top: 49px;
}
.box_6 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 281px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  width: 495px;
}
-group_3 {
  width: 26px;
  height: 27px;
  margin-left: 65px;
}
-group_4 {
  width: 25px;
  height: 27px;
  margin-left: 67px;
}
.text_59 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_1 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
-group_5 {
  width: 38px;
  height: 27px;
  margin-left: 59px;
}
.block_4 {
  width: 136px;
  height: 45px;
  margin: 6px 0 0 43px;
}
.text-wrapper_3 {
  height: 20px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/07dfebe5d32605b46554bc329aac13c3)
  100% no-repeat;
  background-size: 100% 100%;
  width: 136px;
}
.text_60 {
  width: 132px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 2px 0 0 22px;
}
.text-wrapper_4 {
  width: 59px;
  height: 19px;
  margin: 6px 0 0 29px;
}
.text_61 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 36px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 24px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_62 {
  width: 12px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
.block_5 {
  width: 136px;
  height: 45px;
  margin: 6px 0 0 125px;
}
.text-wrapper_5 {
  height: 20px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/310309ce509d3fd3f689d5b5ec241024)
  100% no-repeat;
  background-size: 100% 100%;
  width: 136px;
}
.text_63 {
  width: 125px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 2px 0 0 21px;
}
.text-wrapper_6 {
  width: 97px;
  height: 19px;
  margin: 6px 0 0 36px;
}
.text_64 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 76px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 24px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_65 {
  width: 12px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
.image_1 {
  position: absolute;
  left: 0;
  top: 1px;
  width: 56px;
  height: 56px;
}
.image_2 {
  position: absolute;
  left: 260px;
  top: 0;
  width: 56px;
  height: 56px;
}
-group_6 {
  width: 206px;
  height: 34px;
  margin-left: 5px;
}
.box_7 {
  width: 136px;
  height: 45px;
  margin: 5px 0 0 43px;
}
.image_3 {
  width: 136px;
  height: 20px;
}
.text-wrapper_7 {
  width: 44px;
  height: 19px;
  margin: 6px 0 0 19px;
}
.text_66 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 27px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 24px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_67 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
.text_68 {
  width: 170px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 7px 0 0 -114px;
}
.box_8 {
  width: 136px;
  height: 45px;
  margin: 5px 0 0 68px;
}
.image_4 {
  width: 136px;
  height: 20px;
}
.text-wrapper_8 {
  width: 39px;
  height: 19px;
  margin: 6px 0 0 23px;
}
.text_69 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 24px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 24px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_70 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
.text_71 {
  width: 145px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 7px 0 0 -114px;
}
.image_5 {
  position: absolute;
  left: 0;
  top: 0;
  width: 56px;
  height: 56px;
}
.image_6 {
  position: absolute;
  left: 260px;
  top: 0;
  width: 56px;
  height: 56px;
}
-group_7 {
  width: 89px;
  height: 34px;
  margin-left: 5px;
}
.group_8 {
  width: 139px;
  height: 45px;
  margin: 5px 0 0 43px;
}
.text-wrapper_9 {
  height: 20px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/0a4d49a4842ecc85c478c85a4472c368)
  100% no-repeat;
  background-size: 100% 100%;
  width: 136px;
}
.text_72 {
  width: 135px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 2px 0 0 26px;
}
.text-wrapper_10 {
  width: 120px;
  height: 18px;
  margin: 7px 0 0 19px;
}
.text_73 {
  width: 25px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 7px;
}
.text_74 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 31px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 22px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 8px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_75 {
  width: 12px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 7px 0 0 4px;
}
.text_76 {
  width: 25px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 7px 0 0 15px;
}
.text_77 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 29px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 22px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 32px 0 0 8px;
}
.text_78 {
  width: 12px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 39px 0 0 2px;
}
.group_9 {
  width: 136px;
  height: 45px;
  margin: 5px 0 0 69px;
}
.text-wrapper_11 {
  height: 20px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/60d1f4b4cc169c9ce6c1b154b50f0d32)
  100% no-repeat;
  background-size: 100% 100%;
  width: 136px;
}
.text_79 {
  width: 134px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 2px 0 0 22px;
}
.text-wrapper_12 {
  width: 66px;
  height: 19px;
  margin: 6px 0 0 23px;
}
.text_80 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 50px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 24px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_81 {
  width: 12px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 8px;
}
.image_7 {
  position: absolute;
  left: 0;
  top: 0;
  width: 56px;
  height: 56px;
}
.image_8 {
  position: absolute;
  left: 259px;
  top: 0;
  width: 56px;
  height: 56px;
}
.box_9 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  position: relative;
  width: 495px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-top: 1px;
}
.box_10 {
  width: 210px;
  height: 24px;
  margin: 8px 0 0 285px;
}
.section_2 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
}
.text_82 {
  width: 36px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 6px 0 0 10px;
}
.thumbnail_2 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 16px;
}
.section_3 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 120px;
  height: 24px;
}
.text_83 {
  width: 71px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 6px 0 0 10px;
}
.thumbnail_3 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 21px;
}
.text-wrapper_13 {
  width: 117px;
  height: 17px;
  margin: 54px 0 0 350px;
}
.text_84 {
  width: 70px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 2px;
}
.text_85 {
  width: 34px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text-wrapper_14 {
  width: 116px;
  height: 16px;
  margin: 17px 0 0 351px;
}
.text_86 {
  width: 55px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 1px;
}
.text_87 {
  width: 34px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text-wrapper_15 {
  width: 117px;
  height: 15px;
  margin: 17px 0 0 350px;
}
.text_88 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 1px;
}
.text_89 {
  width: 33px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text-wrapper_16 {
  width: 116px;
  height: 16px;
  margin: 19px 0 0 351px;
}
.text_90 {
  width: 55px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 1px;
}
.text_91 {
  width: 24px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text-wrapper_17 {
  width: 117px;
  height: 16px;
  margin: 20px 0 41px 350px;
}
.text_92 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 1px;
}
.text_93 {
  width: 24px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.box_11 {
  position: absolute;
  left: -24px;
  top: 75px;
  width: 378px;
  height: 226px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/a874193d8bd5ed7fcd5dd3bff6928afa)
    0px -1px no-repeat;
  background-size: 379px 227px;
}
.section_4 {
  background-color: rgba(114, 191, 255, 1);
  width: 14px;
  height: 10px;
  margin: 14px 0 0 353px;
}
.section_5 {
  background-color: rgba(0, 120, 255, 1);
  width: 14px;
  height: 10px;
  margin: 23px 0 0 353px;
}
.section_6 {
  background-color: rgba(252, 245, 194, 1);
  width: 14px;
  height: 10px;
  margin: 23px 0 0 353px;
}
.section_7 {
  background-color: rgba(0, 212, 195, 1);
  width: 14px;
  height: 10px;
  margin: 24px 0 0 353px;
}
.section_8 {
  background-color: rgba(159, 73, 211, 1);
  width: 14px;
  height: 10px;
  margin: 26px 0 66px 353px;
}
.group_10 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 580px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-left: 34px;
  width: 1022px;
  position: relative;
  justify-content: flex-center;
}
.box_12 {
  width: 994px;
  height: 34px;
  margin: 16px 0 0 14px;
}
.block_6 {
  position: relative;
  width: 236px;
  height: 25px;
  margin-top: 6px;
}
.image-wrapper_1 {
  height: 18px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/370bfd09e529c5d8e2cbdcb06e3e703c)
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 7px;
  width: 236px;
}
.thumbnail_4 {
  width: 16px;
  height: 20px;
  margin: -7px 0 0 17px;
}
.text_94 {
  position: absolute;
  left: 45px;
  top: 0;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
}
.block_7 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 100px;
  height: 24px;
  margin-left: 118px;
}
.text_95 {
  width: 35px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 6px 0 0 10px;
}
.card-title {
  width: 100%;
  height: 36px;
  background: url('~img/market/market-card-title.png') no-repeat;
  background-size: 100% 100%;
  padding-left: 17px;
  box-sizing: border-box;
  div {
    font-family: 'AlibabaPB';
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    line-height: 36px;
    // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
    font-style: italic;
    background: linear-gradient(
        180deg,
        rgba(189, 232, 247, 1) 0%,
        rgba(191, 229, 252, 1) 20%,
        rgba(249, 253, 254, 1) 58.7646484375%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.thumbnail_5 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 37px;
}
.block_8 {
  width: 177px;
  height: 21px;
  margin: 4px 0 0 10px;
}
.group_11 {
  width: 122px;
  height: 16px;
}
.thumbnail_6 {
  width: 16px;
  height: 16px;
}
.text_96 {
  width: 95px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(160, 220, 236, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin-top: 2px;
}
.group_12 {
  background-image: linear-gradient(
      90deg,
      rgba(38, 76, 152, 1) 0,
      rgba(38, 76, 152, 1) 0.585938%,
      rgba(38, 76, 152, 0.729412) 12.011719%,
      rgba(92, 182, 255, 1) 48.217773%,
      rgba(92, 182, 255, 1) 48.632812%,
      rgba(92, 182, 255, 0.709804) 89.18457%,
      rgba(38, 76, 152, 1) 99.316406%,
      rgba(38, 76, 152, 1) 99.414062%
  );
  width: 177px;
  height: 2px;
  margin-top: 3px;
}
.block_9 {
  width: 216px;
  height: 28px;
  margin: 6px 0 0 137px;
}
.block_10 {
  width: 125px;
  height: 24px;
  margin-left: 20px;
}
.label_4 {
  width: 22px;
  height: 24px;
}
.text_97 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin-top: 3px;
}
.image_9 {
  width: 216px;
  height: 18px;
  margin-top: -14px;
}
.box_13 {
  width: 991px;
  height: 508px;
  margin: 6px 0 16px 14px;
}
.group_13 {
  position: relative;
  width: 236px;
  height: 508px;
}
.block_11 {
  height: 220px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ab8bf6a51ea79e79dd20b824f1eaaaaf)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 218px;
}
.group_14 {
  width: 193px;
  height: 102px;
  margin: 15px 0 0 14px;
}
.box_14 {
  background-color: rgba(248, 250, 253, 1);
  width: 75px;
  height: 100px;
}
.text-wrapper_18 {
  width: 34px;
  height: 44px;
  margin: 58px 0 0 12px;
}
.text_98 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}
.text_99 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 16px;
}
.text-wrapper_19 {
  width: 66px;
  height: 102px;
  margin-left: 6px;
}
.text_100 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 32px;
}
.text_101 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 44px;
}
.text_102 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 17px;
}
.text-wrapper_20 {
  width: 168px;
  height: 15px;
  margin: 18px 0 0 14px;
}
.text_103 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 1px;
}
.text_104 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_105 {
  width: 33px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 20px;
}
.text_106 {
  width: 41px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 6px;
}
.text-wrapper_21 {
  width: 189px;
  height: 15px;
  margin: 19px 0 36px 14px;
}
.text_107 {
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}
.text_108 {
  width: 12px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.text_109 {
  width: 69px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 36px;
}
.text_110 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 1px 0 0 6px;
}
.image-wrapper_2 {
  height: 18px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/406e15b6edf85de763443a6685d60c13)
    0px -1px no-repeat;
  background-size: 236px 19px;
  margin-top: 31px;
  width: 236px;
}
.image_10 {
  width: 20px;
  height: 22px;
  margin: -10px 0 0 18px;
}
.block_12 {
  width: 218px;
  height: 230px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/b29f7c29efeab77e4d7a14ea53d1c38f)
  100% no-repeat;
  background-size: 100% 100%;
  margin: 9px 0 0 5px;
}
.text_111 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 34px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(114, 191, 255, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 15px 0 0 173px;
}
.text_112 {
  width: 59px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 9px 0 0 14px;
}
.text_113 {
  width: 179px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(246, 248, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 4px 0 0 13px;
}
.text_114 {
  width: 58px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 13px 0 0 14px;
}
.text_115 {
  width: 40px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 4px 0 0 14px;
}
.text_116 {
  width: 57px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 14px 0 0 15px;
}
.text_117 {
  width: 178px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin: 6px 0 0 13px;
}
.text-group_1 {
  width: 88px;
  height: 32px;
  margin: 13px 0 24px 13px;
}
.text_118 {
  width: 87px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(216, 226, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-left: 1px;
}
.text_119 {
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(96, 249, 204, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
  margin-top: 4px;
}
.text_120 {
  position: absolute;
  left: 45px;
  top: 244px;
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
}
.group_15 {
  position: relative;
  width: 514px;
  height: 496px;
  margin: 12px 0 0 23px;
}
.box_15 {
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/c695b17e44715f380a734fef2cf8bea0)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 189px;
  width: 325px;
  position: relative;
}
.text_121 {
  width: 141px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 17px 0 0 102px;
}
.image-wrapper_3 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/98cbb47a25c3decac5893c31c77f4070) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -172px;
  top: 4px;
}
.image_11 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.box_16 {
  position: relative;
  width: 102px;
  height: 105px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/f26217fe72674c95946b120e71da26c3) -2px -4px
  no-repeat;
  background-size: 112px 112px;
  margin: 4px 0 0 176px;
}
.text-wrapper_22 {
  position: absolute;
  left: 58px;
  top: 74px;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/8e54b993c89c68637faee1525815804c)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_122 {
  width: 189px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 9px 0 0 59px;
}
.text_123 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 12px 105px;
}
.text-wrapper_23 {
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/3e6bfe97ec936efaf96c173ee9cd7d34)
  100% no-repeat;
  background-size: 100% 100%;
  width: 325px;
  position: absolute;
  left: 58px;
  top: 10px;
}
.text_124 {
  width: 141px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 18px 0 0 102px;
}
.image-wrapper_4 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/6fc98db83c655fe25bfc5aee89bd2981) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -194px;
  top: 14px;
}
.image_12 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_5 {
  height: 40px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/15de920bb5fa84639f66d37587ab182c) -1px -1px
  no-repeat;
  background-size: 261px 41px;
  width: 260px;
  position: absolute;
  left: -194px;
  top: 77px;
}
.image_13 {
  width: 196px;
  height: 4px;
  margin: -3px 0 0 -65px;
}
.image-wrapper_6 {
  width: 496px;
  height: 18px;
  margin-top: 114px;
}
.image_14 {
  width: 236px;
  height: 18px;
}
.image_15 {
  width: 236px;
  height: 18px;
}
.box_17 {
  width: 478px;
  height: 198px;
  margin: 9px 0 0 5px;
}
.box_18 {
  width: 218px;
  height: 198px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/d90a9ab56a7dd6c9c3df0e8f0c0d58ed)
  100% no-repeat;
  background-size: 100% 100%;
}
.box_19 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 30px;
  margin-top: 13px;
  width: 217px;
}
.box_20 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.section_9 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_10 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_11 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_24 {
  width: 108px;
  height: 13px;
  margin: 3px 0 9px 54px;
}
.text_125 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 108px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_21 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 30px;
  margin-top: 9px;
  width: 217px;
}
.section_12 {
  width: 34px;
  height: 4px;
}
.group_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_25 {
  width: 96px;
  height: 13px;
  margin: 3px 0 10px 60px;
}
.text_126 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_22 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 30px;
  margin-top: 9px;
  width: 217px;
}
.group_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.section_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_26 {
  width: 96px;
  height: 13px;
  margin: 3px 0 9px 60px;
}
.text_127 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 96px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_23 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 30px;
  width: 217px;
  margin: 9px 0 38px 0;
}
.group_20 {
  width: 34px;
  height: 4px;
}
.section_16 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.section_17 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.section_18 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_27 {
  width: 143px;
  height: 12px;
  margin: 5px 0 9px 37px;
}
.text_128 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 143px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_24 {
  width: 218px;
  height: 198px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/50ba2ee5e2451916d291ce28a04ad98d)
  100% no-repeat;
  background-size: 100% 100%;
}
.box_25 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 46px;
  margin-top: 13px;
  width: 217px;
}
.section_19 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.box_26 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_27 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_28 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_28 {
  width: 193px;
  height: 27px;
  margin: 5px 0 9px 14px;
}
.paragraph_2 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 193px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
}
.box_29 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.box_30 {
  width: 34px;
  height: 4px;
  margin-top: 1px;
}
.block_13 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.block_14 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.block_15 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_29 {
  width: 180px;
  height: 13px;
  margin: 3px 0 8px 18px;
}
.text_129 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 180px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_31 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-color: rgba(20, 26, 38, 0.4);
  border-radius: 4px;
  height: 29px;
  margin-top: 10px;
  width: 217px;
}
.section_20 {
  width: 34px;
  height: 4px;
}
.group_21 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.group_22 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.group_23 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_30 {
  width: 163px;
  height: 13px;
  margin: 4px 0 8px 26px;
}
.text_130 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 163px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_32 {
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.83);
  background-image: linear-gradient(
      90deg,
      rgba(52, 114, 223, 0.120784) 0,
      rgba(52, 114, 223, 0.120784) 0.585938%,
      rgba(48, 158, 255, 0.4) 46.655273%,
      rgba(48, 158, 255, 0.4) 49.023438%,
      rgba(48, 158, 255, 0.123922) 99.023438%,
      rgba(52, 114, 223, 0.4) 100%
  );
  border-radius: 4px;
  height: 29px;
  width: 217px;
  margin: 9px 0 23px 0;
}
.group_24 {
  width: 34px;
  height: 4px;
}
.box_33 {
  background-color: rgba(122, 240, 252, 1);
  width: 8px;
  height: 4px;
}
.box_34 {
  background-color: rgba(122, 240, 252, 0.6);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.box_35 {
  background-color: rgba(122, 240, 252, 0.2);
  width: 8px;
  height: 4px;
  margin-left: 5px;
}
.text-wrapper_31 {
  width: 150px;
  height: 12px;
  margin: 5px 0 8px 34px;
}
.text_131 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 150px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.box_36 {
  position: absolute;
  left: 18px;
  top: 260px;
  width: 366px;
  height: 25px;
}
.label_5 {
  width: 22px;
  height: 24px;
  margin-top: 1px;
}
.text_132 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin: 4px 0 0 10px;
}
.label_6 {
  width: 27px;
  height: 24px;
  margin-left: 155px;
}
.text_133 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 18px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 41px;
  margin: 4px 0 0 9px;
}
.group_25 {
  width: 208px;
  height: 505px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/99d8f2cf537e143367968988c95e8984)
  100% no-repeat;
  background-size: 100% 100%;
  margin: 3px 0 0 10px;
}
.box_37 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 7px 0 0 4px;
}
.text_134 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 82px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 55px;
}
.image_16 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_17 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_38 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_135 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 106px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 7px 0 0 47px;
}
.image_18 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_19 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_39 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_3 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 134px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 32px;
}
.image_20 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_21 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_40 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_4 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 122px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 8px 0 0 38px;
}
.image_22 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_23 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_41 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_5 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 101px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 49px;
}
.image_24 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_25 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_42 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_6 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 125px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_26 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_27 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_43 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.paragraph_7 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 132px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 8px 0 0 33px;
}
.image_28 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_29 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_44 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  width: 200px;
  position: relative;
  margin: 13px 0 0 4px;
}
.text_136 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 118px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 41px;
}
.image_30 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_31 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_45 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 43px;
  width: 200px;
  position: relative;
  margin: 14px 0 0 4px;
}
.paragraph_8 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 14px;
  margin: 7px 0 0 37px;
}
.image_32 {
  position: absolute;
  left: 4px;
  top: 40px;
  width: 196px;
  height: 4px;
}
.image_33 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_46 {
  background-color: rgba(38, 89, 188, 0.52);
  border-radius: 3px;
  height: 28px;
  width: 200px;
  position: relative;
  margin: 13px 0 8px 4px;
}
.text_137 {
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.59);
  width: 120px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 8px 0 0 40px;
}
.image_34 {
  position: absolute;
  left: 4px;
  top: 25px;
  width: 196px;
  height: 4px;
}
.image_35 {
  position: absolute;
  left: 4px;
  top: -1px;
  width: 196px;
  height: 4px;
}
.box_47 {
  position: absolute;
  left: 485px;
  top: 255px;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/426c1d36984ebed92a837393c2a411e0)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_138 {
  width: 142px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 108px;
}
.text_139 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 11px 131px;
}
.text-wrapper_32 {
  position: absolute;
  left: -278px;
  top: 0;
  width: 325px;
  height: 48px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ea8f102e075ca88cf106e7c207ed5e2e)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_140 {
  width: 189px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 77px;
}
.text_141 {
  width: 96px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 11px 123px;
}
.text-wrapper_33 {
  position: absolute;
  left: 286px;
  top: 68px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/aaaa44abff14d677c108bf81808690fb)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_142 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_143 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_34 {
  position: absolute;
  left: 251px;
  top: 130px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/a605f2cf9d740583581ebbca6b9106a8)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_144 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_145 {
  width: 67px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 4px 0 10px 60px;
}
.text-wrapper_35 {
  position: absolute;
  left: 251px;
  top: 193px;
  width: 264px;
  height: 47px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/76c9b6163c7c219ce215221bd4b14ca2)
  0px 0px no-repeat;
  background-size: 265px 48px;
  justify-content: flex-center;
}
.text_146 {
  width: 155px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 14px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 10px 0 0 16px;
}
.text_147 {
  width: 94px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(247, 249, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 3px 0 10px 47px;
}
.group_26 {
  width: 495px;
  height: 569px;
  margin: 11px 0 0 34px;
}
.group_27 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.28) 3.735352%,
      rgba(58, 90, 127, 0.35) 44.287109%,
      rgba(58, 90, 127, 0.28) 97.045898%,
      rgba(6, 17, 29, 0.35) 100%,
      rgba(6, 17, 29, 0.35) 100%
  );
  border-radius: 4px;
  position: relative;
  width: 495px;
  height: 239px;
  border: 1px solid rgba(148, 255, 255, 0.15);
}
.block_16 {
  width: 475px;
  height: 31px;
  margin: 7px 0 0 20px;
}
.text_148 {
  width: 48px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-top: 18px;
}
.box_48 {
  background-color: rgba(73, 172, 255, 0.5);
  width: 13px;
  height: 9px;
  border: 1px solid rgba(73, 172, 255, 1);
  margin: 10px 0 0 33px;
}
.text_149 {
  width: 48px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 8px 0 0 9px;
}
.box_49 {
  background-color: rgba(0, 212, 195, 0.5);
  width: 13px;
  height: 9px;
  border: 1px solid rgba(0, 212, 195, 1);
  margin: 10px 0 0 86px;
}
.text_150 {
  width: 60px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 8px 0 0 8px;
}
.box_50 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
  margin-left: 77px;
}
.text_151 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_7 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.block_17 {
  width: 468px;
  height: 170px;
  margin: 5px 0 0 10px;
}
.paragraph_9 {
  width: 39px;
  height: 170px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: right;
  line-height: 16px;
}
.group_28 {
  width: 417px;
  height: 163px;
  margin-top: 4px;
}
.image_36 {
  width: 415px;
  height: 2px;
}
.image_37 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_38 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_39 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_40 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_41 {
  width: 415px;
  height: 2px;
  margin-top: 15px;
}
.image_42 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_43 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.image_44 {
  width: 415px;
  height: 2px;
  margin-top: 14px;
}
.block_18 {
  height: 2px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/12b2bb58cf3ba03427b626462c11bc2a) -1px -1px
  no-repeat;
  background-size: 416px 3px;
  width: 415px;
  margin: 15px 0 0 2px;
}
.section_21 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  width: 7px;
  height: 16px;
  border: 1px solid rgba(0, 212, 195, 1);
  margin-left: 292px;
}
.block_19 {
  position: relative;
  width: 415px;
  height: 2px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/70177705845f91eaefb5fd89044c59ab) -1px
  0px no-repeat;
  background-size: 416px 3px;
  margin-top: 13px;
}
.group_29 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 259px;
  top: -11px;
  width: 7px;
  height: 12px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.group_30 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 328px;
  top: -13px;
  width: 7px;
  height: 14px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.group_31 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 318px;
  top: -13px;
  width: 7px;
  height: 14px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_32 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 363px;
  top: -11px;
  width: 7px;
  height: 12px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.group_33 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 397px;
  top: -11px;
  width: 7px;
  height: 12px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.group_34 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 387px;
  top: -11px;
  width: 7px;
  height: 12px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.text_152 {
  width: 404px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 2px 0 11px 65px;
}
.block_20 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 79px;
  top: 81px;
  width: 7px;
  height: 128px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.block_21 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 69px;
  top: 61px;
  width: 7px;
  height: 148px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_22 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 99.414062%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 113px;
  top: 135px;
  width: 7px;
  height: 74px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_23 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 103px;
  top: 118px;
  width: 7px;
  height: 92px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_24 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 148px;
  top: 135px;
  width: 7px;
  height: 74px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_25 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 138px;
  top: 116px;
  width: 7px;
  height: 94px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_26 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 182px;
  top: 158px;
  width: 7px;
  height: 51px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_27 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 172px;
  top: 158px;
  width: 7px;
  height: 52px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_28 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 217px;
  top: 172px;
  width: 7px;
  height: 37px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_29 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 207px;
  top: 165px;
  width: 7px;
  height: 44px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_30 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 251px;
  top: 180px;
  width: 7px;
  height: 29px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_31 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 241px;
  top: 180px;
  width: 7px;
  height: 30px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_32 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  position: absolute;
  left: 286px;
  top: 185px;
  width: 7px;
  height: 24px;
  border: 1px solid rgba(0, 212, 195, 1);
}
.block_33 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 276px;
  top: 170px;
  width: 7px;
  height: 40px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_34 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 310px;
  top: 181px;
  width: 7px;
  height: 28px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_35 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 345px;
  top: 189px;
  width: 7px;
  height: 20px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.block_36 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 414px;
  top: 191px;
  width: 7px;
  height: 18px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_35 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-top: 50px;
  width: 495px;
}
.box_51 {
  width: 80px;
  height: 24px;
  margin: 8px 0 0 415px;
}
.group_36 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
}
.text_153 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_8 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.box_52 {
  position: relative;
  width: 493px;
  height: 200px;
  margin: 47px 0 1px -20px;
}
.group_37 {
  width: 61px;
  height: 160px;
  margin-left: 325px;
}
.text_154 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 1px;
}
.text-wrapper_36 {
  width: 59px;
  height: 15px;
  margin: 9px 0 0 2px;
}
.text_155 {
  width: 43px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text_156 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 4px;
}
.text_157 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 22px 0 0 1px;
}
.text-wrapper_37 {
  width: 61px;
  height: 15px;
  margin-top: 9px;
}
.text_158 {
  width: 44px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text_159 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 4px;
}
.text_160 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 21px 0 0 1px;
}
.text-wrapper_38 {
  width: 61px;
  height: 15px;
  margin-top: 9px;
}
.text_161 {
  width: 44px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text_162 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 4px;
}
.text-wrapper_39 {
  width: 60px;
  height: 136px;
  margin: 24px 0 0 31px;
}
.text_163 {
  width: 49px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 11px;
}
.text_164 {
  width: 57px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 46px;
}
.text_165 {
  width: 57px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 45px;
}
.text-wrapper_40 {
  width: 12px;
  height: 133px;
  margin: 29px 0 0 4px;
}
.text_166 {
  width: 12px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.text_167 {
  width: 12px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 49px;
}
.text_168 {
  width: 12px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 48px;
}
.group_38 {
  position: absolute;
  left: 0;
  top: 2px;
  width: 331px;
  height: 198px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/81a9694e27a3aee09f245a79361fcdbb)
  100% no-repeat;
  background-size: 100% 100%;
}
.box_53 {
  background-color: rgba(126, 198, 255, 1);
  width: 14px;
  height: 10px;
  margin: 60px 0 0 305px;
}
.box_54 {
  background-color: rgba(0, 120, 255, 1);
  width: 14px;
  height: 10px;
  margin: 50px 0 68px 305px;
}
.box_55 {
  background-color: rgba(252, 245, 194, 1);
  position: absolute;
  left: 305px;
  top: -1px;
  width: 14px;
  height: 10px;
}
.group_39 {
  width: 495px;
  height: 569px;
  margin: 11px 0 0 32px;
}
.group_40 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.28) 3.735352%,
      rgba(58, 90, 127, 0.35) 44.287109%,
      rgba(58, 90, 127, 0.28) 97.045898%,
      rgba(6, 17, 29, 0.35) 100%,
      rgba(6, 17, 29, 0.35) 100%
  );
  border-radius: 4px;
  width: 495px;
  height: 239px;
  border: 1px solid rgba(148, 255, 255, 0.15);
}
.section_22 {
  width: 446px;
  height: 24px;
  margin: 7px 0 0 49px;
}
.block_37 {
  background-image: linear-gradient(
      90deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 116, 198, 1) 100%,
      rgba(0, 116, 198, 1) 100%
  );
  border-radius: 4px;
  width: 13px;
  height: 8px;
  margin-top: 11px;
}
.text_169 {
  width: 60px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 7px 0 0 9px;
}
.block_38 {
  background-image: linear-gradient(
      90deg,
      rgba(0, 198, 126, 1) 0,
      rgba(0, 198, 126, 1) 0,
      rgba(0, 212, 195, 1) 100%,
      rgba(0, 212, 195, 1) 100%
  );
  border-radius: 4px;
  width: 13px;
  height: 8px;
  margin: 11px 0 0 24px;
}
.text_170 {
  width: 60px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 7px 0 0 9px;
}
.text_171 {
  width: 148px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(243, 199, 129, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 9px 0 0 18px;
}
.block_39 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
  margin-left: 12px;
}
.text_172 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_9 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.image_45 {
  width: 464px;
  height: 188px;
  margin: 8px 0 12px 18px;
}
.group_41 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 281px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-top: 49px;
  width: 495px;
}
.box_56 {
  width: 80px;
  height: 24px;
  margin: 8px 0 0 415px;
}
.block_40 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
}
.text_173 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_10 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.box_57 {
  width: 461px;
  height: 212px;
  margin: 14px 0 23px 17px;
}
.image_46 {
  width: 194px;
  height: 212px;
}
.group_42 {
  width: 14px;
  height: 92px;
  margin: 68px 0 0 11px;
}
.block_41 {
  background-color: rgba(0, 97, 246, 1);
  width: 14px;
  height: 10px;
}
.block_42 {
  background-color: rgba(0, 165, 255, 1);
  width: 14px;
  height: 10px;
  margin-top: 32px;
}
.block_43 {
  background-color: rgba(55, 232, 251, 1);
  width: 14px;
  height: 10px;
  margin-top: 30px;
}
.text-wrapper_41 {
  width: 99px;
  height: 96px;
  margin: 67px 0 0 7px;
}
.text_174 {
  width: 84px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.paragraph_10 {
  width: 98px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
  margin-top: 19px;
}
.text_175 {
  width: 99px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 19px;
}
.text-wrapper_42 {
  width: 46px;
  height: 96px;
  margin: 66px 0 0 16px;
}
.text_176 {
  width: 35px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 9px;
}
.text_177 {
  width: 45px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin: 27px 0 0 1px;
}
.text_178 {
  width: 43px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 24px;
}
.text-wrapper_43 {
  width: 11px;
  height: 93px;
  margin: 70px 0 0 3px;
}
.text_179 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.text_180 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 32px;
}
.text_181 {
  width: 11px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 28px;
}
.group_43 {
  width: 50px;
  height: 99px;
  margin: 66px 0 0 10px;
}
.text-wrapper_44 {
  width: 40px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 10px;
}
.text_182 {
  width: 40px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_183 {
  width: 40px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_184 {
  width: 40px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text-wrapper_45 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 22px;
}
.text_185 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_186 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_187 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text-wrapper_46 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 23px;
}
.text_188 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_189 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.text_190 {
  width: 50px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}
.block_44 {
  width: 3135px;
  height: 281px;
  margin: 51px 0 33px 32px;
}
.group_44 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  position: relative;
  width: 495px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-top: 1px;
}
.group_45 {
  width: 393px;
  height: 24px;
  margin: 7px 0 0 102px;
}
.box_58 {
  background-color: rgba(73, 172, 255, 0.5);
  width: 13px;
  height: 9px;
  border: 1px solid rgba(73, 172, 255, 1);
  margin-top: 10px;
}
.text_191 {
  width: 108px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 9px 0 0 8px;
}
.box_59 {
  background-color: rgba(22, 68, 185, 0.5);
  width: 13px;
  height: 9px;
  border: 1px solid rgba(22, 68, 185, 1);
  margin: 10px 0 0 25px;
}
.text_192 {
  width: 60px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 8px 0 0 9px;
}
.box_60 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
  margin-left: 77px;
}
.text_193 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_11 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.text_194 {
  width: 47px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 4px 0 0 20px;
}
.group_46 {
  width: 456px;
  height: 194px;
  margin: 11px 0 0 21px;
}
.paragraph_11 {
  width: 28px;
  height: 194px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: right;
  line-height: 23px;
}
.image-wrapper_7 {
  width: 417px;
  height: 187px;
  margin-top: 4px;
}
.image_47 {
  width: 415px;
  height: 2px;
}
.image_48 {
  width: 415px;
  height: 2px;
  margin-top: 21px;
}
.image_49 {
  width: 415px;
  height: 2px;
  margin-top: 21px;
}
.image_50 {
  width: 415px;
  height: 2px;
  margin-top: 21px;
}
.image_51 {
  width: 415px;
  height: 2px;
  margin-top: 22px;
}
.image_52 {
  width: 415px;
  height: 2px;
  margin-top: 21px;
}
.image_53 {
  width: 415px;
  height: 2px;
  margin-top: 21px;
}
.image_54 {
  width: 415px;
  height: 2px;
  margin: 22px 0 0 2px;
}
.image_55 {
  width: 415px;
  height: 2px;
  margin-top: 20px;
}
.text_195 {
  width: 403px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 2px 0 12px 66px;
}
.group_47 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 79px;
  top: 182px;
  width: 7px;
  height: 67px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_48 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 69px;
  top: 130px;
  width: 7px;
  height: 120px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_49 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 113px;
  top: 179px;
  width: 7px;
  height: 70px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_50 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 103px;
  top: 91px;
  width: 7px;
  height: 158px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_51 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 148px;
  top: 222px;
  width: 7px;
  height: 27px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_52 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 138px;
  top: 211px;
  width: 7px;
  height: 38px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_53 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 182px;
  top: 167px;
  width: 7px;
  height: 82px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_54 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 172px;
  top: 122px;
  width: 7px;
  height: 128px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_55 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 217px;
  top: 179px;
  width: 7px;
  height: 70px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_56 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 207px;
  top: 154px;
  width: 7px;
  height: 96px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_57 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 251px;
  top: 180px;
  width: 7px;
  height: 69px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_58 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 241px;
  top: 137px;
  width: 7px;
  height: 112px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_59 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 286px;
  top: 192px;
  width: 7px;
  height: 57px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_60 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 276px;
  top: 186px;
  width: 7px;
  height: 64px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_61 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 320px;
  top: 185px;
  width: 7px;
  height: 64px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_62 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 310px;
  top: 179px;
  width: 7px;
  height: 70px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_63 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 355px;
  top: 186px;
  width: 7px;
  height: 63px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_64 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 345px;
  top: 166px;
  width: 7px;
  height: 84px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_65 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 389px;
  top: 193px;
  width: 7px;
  height: 56px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_66 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 379px;
  top: 187px;
  width: 7px;
  height: 62px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_67 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 424px;
  top: 192px;
  width: 7px;
  height: 57px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_68 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 414px;
  top: 186px;
  width: 7px;
  height: 64px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_69 {
  background-image: linear-gradient(
      180deg,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 0,
      rgba(22, 68, 185, 1) 100%,
      rgba(22, 68, 185, 1) 100%
  );
  position: absolute;
  left: 458px;
  top: 152px;
  width: 7px;
  height: 97px;
  border: 1px solid rgba(22, 68, 185, 1);
}
.group_70 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 100%,
      rgba(73, 172, 255, 1) 100%
  );
  position: absolute;
  left: 448px;
  top: 126px;
  width: 7px;
  height: 124px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.group_71 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  width: 495px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin: 1px 0 0 33px;
}
.group_72 {
  width: 210px;
  height: 24px;
  margin: 8px 0 0 285px;
}
.group_73 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
}
.text_196 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_12 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.group_74 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 120px;
  height: 24px;
}
.text_197 {
  width: 71px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 6px 0 0 10px;
}
.thumbnail_13 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 21px;
}
.group_75 {
  width: 307px;
  height: 27px;
  margin: 17px 0 0 92px;
}
.text-group_2 {
  width: 27px;
  height: 27px;
}
.text_198 {
  background-image: linear-gradient(
      180deg,
      rgba(246, 61, 1, 1) 0,
      rgba(246, 61, 1, 1) 0.12207%,
      rgba(246, 61, 1, 1) 77.001953%
  );
  width: 25px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 2px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_199 {
  width: 25px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(253, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  margin-top: 5px;
}
.text-group_3 {
  width: 26px;
  height: 27px;
  margin-left: 65px;
}
.text_200 {
  background-image: linear-gradient(
      180deg,
      rgba(244, 143, 0, 1) 0,
      rgba(244, 143, 0, 1) 0,
      rgba(244, 143, 0, 1) 77.001953%
  );
  width: 26px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 23px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_201 {
  width: 24px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(253, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  margin: 5px 0 0 1px;
}
.text-group_4 {
  width: 25px;
  height: 27px;
  margin-left: 67px;
}
.text_202 {
  background-image: linear-gradient(
      180deg,
      rgba(130, 244, 14, 1) 0,
      rgba(130, 244, 14, 1) 0.12207%,
      rgba(130, 244, 14, 1) 77.001953%
  );
  width: 18px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 4px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_203 {
  width: 25px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(253, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  margin-top: 5px;
}
.text-group_5 {
  width: 38px;
  height: 27px;
  margin-left: 59px;
}
.text_204 {
  background-image: linear-gradient(
      187deg,
      rgba(245, 248, 255, 1) 0,
      rgba(245, 248, 255, 1) 0.12207%,
      rgba(245, 248, 255, 1) 77.001953%
  );
  width: 18px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 13px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_205 {
  width: 38px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(253, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  margin-top: 5px;
}
.image-wrapper_8 {
  width: 343px;
  height: 129px;
  margin: 12px 0 0 71px;
}
.image_56 {
  width: 68px;
  height: 129px;
}
.image_57 {
  width: 68px;
  height: 129px;
  margin-left: 24px;
}
.image_58 {
  width: 68px;
  height: 129px;
  margin-left: 25px;
}
.image_59 {
  width: 68px;
  height: 129px;
  margin-left: 22px;
}
.group_76 {
  width: 345px;
  height: 34px;
  margin: 15px 0 14px 77px;
}
.box_61 {
  width: 10px;
  height: 31px;
  margin-top: 1px;
}
.block_45 {
  background-color: rgba(255, 124, 58, 1);
  border-radius: 50%;
  width: 10px;
  height: 10px;
}
.block_46 {
  background-color: rgba(255, 205, 126, 1);
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-top: 11px;
}
.text-group_6 {
  width: 206px;
  height: 34px;
  margin-left: 5px;
}
.text_206 {
  width: 195px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.text_207 {
  width: 206px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 8px;
}
.box_62 {
  width: 10px;
  height: 31px;
  margin: 1px 0 0 20px;
}
.group_77 {
  background-color: rgba(96, 249, 204, 1);
  border-radius: 50%;
  width: 10px;
  height: 10px;
}
.group_78 {
  background-color: rgba(93, 201, 255, 1);
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-top: 11px;
}
.text-group_7 {
  width: 89px;
  height: 34px;
  margin-left: 5px;
}
.text_208 {
  width: 74px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.text_209 {
  width: 89px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 11px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 8px;
}
.group_79 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  width: 1022px;
  position: relative;
  margin: 1px 0 0 36px;
}
.box_63 {
  width: 978px;
  height: 46px;
  margin: 15px 0 0 21px;
}
.label_7 {
  width: 43px;
  height: 46px;
}
.image_60 {
  width: 476px;
  height: 18px;
  margin: 6px 0 0 17px;
}
.text-wrapper_47 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 24px;
  margin: 5px 0 0 -460px;
}
.text_210 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_211 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(212, 189, 89, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.paragraph_12 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_212 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_213 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text_214 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(255, 97, 99, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_215 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(254, 222, 85, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}
.text_216 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(239, 240, 241, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  line-height: 16px;
}
.text-wrapper_48 {
  width: 513px;
  height: 14px;
  margin: 45px 0 0 452px;
}
.text_217 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.text_218 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 103px;
}
.text_219 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 83px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 122px;
}
.text_220 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 28px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 65px;
}
.text-wrapper_49 {
  width: 533px;
  height: 31px;
  margin: 32px 0 0 456px;
}
.text_221 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 50px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 8px;
}
.paragraph_13 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 207px;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin-left: 30px;
}
.text_222 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 112px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 29px;
  margin: 8px 0 0 37px;
}
.text_223 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 74px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(252, 66, 66, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 8px 0 0 23px;
}
.text-wrapper_50 {
  width: 533px;
  height: 14px;
  margin: 32px 0 51px 456px;
}
.text_224 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 50px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
}
.text_225 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 219px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 25px;
}
.text_226 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 106px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 29px;
  margin-left: 30px;
}
.text_227 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 74px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(252, 66, 66, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 29px;
}
.box_64 {
  height: 229px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/fc9e609a824d9ed00f7c23f67fa013bb)
  100% no-repeat;
  background-size: 100% 100%;
  width: 484px;
  position: absolute;
  left: 6px;
  top: 76px;
}
.text-wrapper_51 {
  width: 387px;
  height: 14px;
  margin: 30px 0 0 29px;
}
.text_228 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 69px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
}
.text_229 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 44px;
}
.text_230 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 63px;
}
.text_231 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.5);
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-left: 43px;
}
.text-wrapper_52 {
  width: 380px;
  height: 31px;
  margin: 31px 0 0 45px;
}
.text_232 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 37px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 10px;
}
.paragraph_14 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 98px;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin-left: 39px;
}
.paragraph_15 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 84px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin: 1px 0 0 28px;
}
.text_233 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 74px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 9px 0 0 20px;
}
.text-wrapper_53 {
  width: 368px;
  height: 33px;
  margin: 24px 0 66px 45px;
}
.text_234 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 38px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin-top: 10px;
}
.paragraph_16 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 98px;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin-left: 38px;
}
.paragraph_17 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 78px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 18px;
  margin-left: 31px;
}
.text_235 {
  text-shadow: 0px 6px 10px rgba(24, 8, 8, 0.7);
  width: 49px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(227, 227, 227, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 9px 0 0 36px;
}
.group_80 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.35) 0,
      rgba(6, 17, 29, 0.28) 3.735352%,
      rgba(58, 90, 127, 0.35) 44.287109%,
      rgba(58, 90, 127, 0.28) 97.045898%,
      rgba(6, 17, 29, 0.35) 100%,
      rgba(6, 17, 29, 0.35) 100%
  );
  border-radius: 4px;
  position: relative;
  width: 495px;
  height: 280px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  margin-left: 32px;
}
.box_65 {
  width: 404px;
  height: 24px;
  margin: 7px 0 0 91px;
}
.box_66 {
  background-image: linear-gradient(
      180deg,
      rgba(72, 171, 255, 1) 0,
      rgba(72, 171, 255, 1) 0,
      rgba(2, 140, 255, 1) 100%,
      rgba(2, 140, 255, 1) 100%
  );
  width: 13px;
  height: 9px;
  border: 1px solid rgba(73, 172, 255, 1);
  margin-top: 10px;
}
.text_236 {
  width: 48px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 8px 0 0 9px;
}
.box_67 {
  background-image: linear-gradient(
      180deg,
      rgba(1, 175, 161, 1) 0,
      rgba(1, 175, 161, 1) 0,
      rgba(17, 252, 233, 1) 99.194336%,
      rgba(17, 252, 233, 1) 100%
  );
  width: 13px;
  height: 9px;
  border: 1px solid rgba(0, 212, 195, 1);
  margin: 12px 0 0 28px;
}
.text_237 {
  width: 48px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 10px 0 0 13px;
}
.box_68 {
  background-color: rgba(226, 190, 36, 1);
  width: 16px;
  height: 2px;
  margin: 16px 0 0 23px;
}
.text_238 {
  width: 72px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 9px 0 0 6px;
}
.box_69 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
  margin-left: 35px;
}
.text_239 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_14 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.text_240 {
  width: 48px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 2px 0 0 20px;
}
.box_70 {
  width: 466px;
  height: 199px;
  margin: 7px 0 0 19px;
}
.paragraph_18 {
  width: 20px;
  height: 199px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: right;
  line-height: 21px;
}
.box_71 {
  width: 386px;
  height: 191px;
  margin: 4px 0 0 12px;
}
.image_61 {
  width: 386px;
  height: 2px;
}
.image_62 {
  width: 386px;
  height: 2px;
  margin-top: 19px;
}
.image_63 {
  width: 386px;
  height: 2px;
  margin-top: 19px;
}
.image_64 {
  width: 386px;
  height: 2px;
  margin-top: 19px;
}
.image_65 {
  width: 386px;
  height: 2px;
  margin-top: 19px;
}
.image_66 {
  width: 386px;
  height: 2px;
  margin-top: 20px;
}
.image_67 {
  width: 386px;
  height: 2px;
  margin-top: 19px;
}
.image_68 {
  width: 386px;
  height: 2px;
  margin-top: 18px;
}
.group_81 {
  height: 2px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/de6bfcd9a75e24362a59044afd1f294b) -1px -1px
  no-repeat;
  background-size: 387px 3px;
  margin-top: 20px;
  width: 386px;
}
.box_72 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  width: 7px;
  height: 21px;
  border: 1px solid rgba(0, 209, 181, 1);
  margin-left: 156px;
}
.group_82 {
  position: relative;
  width: 386px;
  height: 2px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/9907f7a93b0abac4870a3abaf7cc04a8) -1px
  0px no-repeat;
  background-size: 387px 3px;
  margin-top: 18px;
}
.box_73 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 87px;
  top: -18px;
  width: 7px;
  height: 19px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_74 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 121px;
  top: -18px;
  width: 7px;
  height: 19px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_75 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 326px;
  top: -14px;
  width: 7px;
  height: 15px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_76 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 360px;
  top: -17px;
  width: 7px;
  height: 18px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.paragraph_19 {
  width: 38px;
  height: 198px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 11px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  line-height: 21px;
  margin-left: 10px;
}
.text_241 {
  width: 368px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(192, 192, 192, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 1px 0 14px 55px;
}
.box_77 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 68px;
  top: 179px;
  width: 7px;
  height: 68px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_78 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 59px;
  top: 158px;
  width: 7px;
  height: 90px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_79 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 103px;
  top: 182px;
  width: 7px;
  height: 65px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_80 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 94px;
  top: 148px;
  width: 7px;
  height: 100px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_81 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 129px;
  top: 218px;
  width: 7px;
  height: 30px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_82 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 163px;
  top: 222px;
  width: 7px;
  height: 26px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_83 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 198px;
  top: 210px;
  width: 7px;
  height: 38px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_84 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 240px;
  top: 225px;
  width: 7px;
  height: 22px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_85 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 231px;
  top: 215px;
  width: 7px;
  height: 32px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_86 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 275px;
  top: 225px;
  width: 7px;
  height: 22px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_87 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 266px;
  top: 205px;
  width: 7px;
  height: 42px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_88 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 310px;
  top: 197px;
  width: 7px;
  height: 50px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_89 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 301px;
  top: 149px;
  width: 7px;
  height: 98px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_90 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 171, 157, 1) 0,
      rgba(0, 171, 157, 1) 0,
      rgba(17, 255, 236, 1) 100%,
      rgba(17, 255, 236, 1) 100%
  );
  position: absolute;
  left: 345px;
  top: 224px;
  width: 7px;
  height: 23px;
  border: 1px solid rgba(0, 209, 181, 1);
}
.box_91 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 336px;
  top: 201px;
  width: 7px;
  height: 46px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_92 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 368px;
  top: 221px;
  width: 7px;
  height: 26px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.box_93 {
  background-image: linear-gradient(
      180deg,
      rgba(73, 172, 255, 1) 0,
      rgba(73, 172, 255, 1) 0,
      rgba(0, 139, 255, 1) 100%,
      rgba(0, 139, 255, 1) 100%
  );
  position: absolute;
  left: 402px;
  top: 203px;
  width: 7px;
  height: 44px;
  border: 1px solid rgba(73, 172, 255, 1);
}
.image_69 {
  position: absolute;
  left: 66px;
  top: 133px;
  width: 344px;
  height: 55px;
}
.group_83 {
  background-image: linear-gradient(
      90deg,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.26) 0,
      rgba(6, 17, 29, 0.208) 3.735352%,
      rgba(58, 90, 127, 0.26) 44.287109%,
      rgba(58, 90, 127, 0.208) 97.045898%,
      rgba(6, 17, 29, 0.26) 100%,
      rgba(6, 17, 29, 0.26) 100%
  );
  border-radius: 4px;
  height: 278px;
  border: 1px solid rgba(148, 255, 255, 0.15);
  width: 495px;
  margin: 1px 0 0 32px;
}
.block_47 {
  width: 80px;
  height: 24px;
  margin: 8px 0 0 415px;
}
.group_84 {
  background-image: linear-gradient(
      180deg,
      rgba(57, 108, 206, 1) 0,
      rgba(57, 108, 206, 0.501961) 0,
      rgba(61, 164, 255, 1) 6.005859%,
      rgba(57, 108, 206, 1) 100%,
      rgba(57, 108, 206, 0.109804) 100%
  );
  border-radius: 3px;
  width: 80px;
  height: 24px;
}
.text_242 {
  width: 27px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 37px;
  margin: 7px 0 0 10px;
}
.thumbnail_15 {
  width: 12px;
  height: 6px;
  margin: 9px 6px 0 25px;
}
.block_48 {
  width: 412px;
  height: 192px;
  margin: 17px 0 37px 45px;
}
.image_70 {
  width: 192px;
  height: 192px;
}
.group_85 {
  width: 15px;
  height: 143px;
  margin: 24px 0 0 47px;
}
.block_49 {
  background-color: rgba(0, 201, 255, 1);
  width: 15px;
  height: 11px;
  border: 1px solid rgba(0, 201, 255, 1);
}
.block_50 {
  background-color: rgba(0, 120, 255, 1);
  width: 14px;
  height: 10px;
  margin: 22px 0 0 1px;
}
.block_51 {
  background-color: rgba(11, 227, 210, 1);
  width: 14px;
  height: 10px;
  margin: 24px 0 0 1px;
}
.block_52 {
  background-color: rgba(252, 245, 194, 1);
  width: 14px;
  height: 10px;
  margin: 23px 0 0 1px;
}
.block_53 {
  background-color: rgba(255, 124, 58, 1);
  width: 14px;
  height: 10px;
  margin: 23px 0 0 1px;
}
.text-wrapper_54 {
  width: 78px;
  height: 146px;
  margin: 24px 0 0 7px;
}
.text_243 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}
.text_244 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 18px;
}
.text_245 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 20px;
}
.text_246 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 19px;
}
.text_247 {
  width: 78px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(220, 220, 220, 1);
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-top: 19px;
}
.text-wrapper_55 {
  width: 40px;
  height: 148px;
  margin: 22px 0 0 33px;
}
.text_248 {
  width: 37px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
}
.text_249 {
  width: 38px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin: 18px 0 0 2px;
}
.text_250 {
  width: 28px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin: 19px 0 0 9px;
}
.text_251 {
  width: 27px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin: 18px 0 0 8px;
}
.text_252 {
  width: 18px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Geometric706BT-BlackCondensedB;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 30px;
  margin: 18px 0 0 20px;
}
.text-wrapper_56 {
  height: 36px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/7b1fa2b8d773eeace2fd9fb7c7280480)
  100% no-repeat;
  background-size: 100% 100%;
  width: 498px;
  position: absolute;
  left: 31px;
  top: 4px;
}
.text_253 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 8px 0 0 18px;
}
.text-wrapper_57 {
  height: 36px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/61fa7c5837793b64561406f115b2c897)
  100% no-repeat;
  background-size: 100% 100%;
  width: 498px;
  position: absolute;
  left: 1086px;
  top: 4px;
}
.text_254 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 98px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 8px 0 0 18px;
}
.block_54 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/41fa1e6546bb8b58f03ce8803a0fa7bb)
    0px -1px no-repeat;
  background-size: 494px 32px;
  width: 494px;
  position: absolute;
  left: 2145px;
  top: 13px;
}
.block_55 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/2f656eb82095443df2cb85a17d830f46)
    0px -1px no-repeat;
  background-size: 494px 32px;
  width: 494px;
  position: relative;
}
.section_23 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/f71b18e94b9eb86410887ffbae9d8c72)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_86 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.section_24 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/3f2e8976d36d4a39b12f2cd0f30ef1b2_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_255 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 318px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 17px;
}
.image_71 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 27px;
}
.image_72 {
  position: absolute;
  left: 351px;
  top: -1px;
  width: 139px;
  height: 5px;
}
.thumbnail_16 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_56 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/77b89e89ccd82e2162c341a27775e52d)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 2145px;
  top: 633px;
}
.section_25 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/248ebd0af22088f110e86b9cd2f6621e)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.box_94 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/cabd74cc37c3648d3f402618d5abf8fc)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.box_95 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_96 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/ebc54235171944169c73bb258133eaa1_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_256 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 275px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_73 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 71px;
}
.image_74 {
  position: absolute;
  left: 351px;
  top: -1px;
  width: 139px;
  height: 5px;
}
.thumbnail_17 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_57 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/fd2519f3815d037d1aa53db2eeae5fc5)
    0px -1px no-repeat;
  background-size: 494px 32px;
  width: 494px;
  position: absolute;
  left: 2672px;
  top: 13px;
}
.group_87 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/7b13e2b214e7a85f54451dc6a2a26213)
    0px -1px no-repeat;
  background-size: 494px 32px;
  width: 494px;
  position: relative;
}
.box_97 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/df749c50643dbb7f39bf8c59317b3959)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_88 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_98 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/e3e3550213c84bffac132f939fb159f2_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_257 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 256px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_75 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 90px;
}
.image_76 {
  position: absolute;
  left: 351px;
  top: -1px;
  width: 139px;
  height: 5px;
}
.thumbnail_18 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_58 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/769030d03310117c3487e0f4bf7deb24)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 560px;
  top: 302px;
}
.box_99 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/e006deb63445cf44439082d40dc1c6c2)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.box_100 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/9e4185481fdf18ca901958d1c68e9c6f)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_89 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_101 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/687b3c19fff1432b9a8a77089d92cad2_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_258 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 197px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_77 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 149px;
}
.image_78 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_19 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_59 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/8c8164cce8112d6981cb0a2ea3c0d379)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 560px;
  top: 634px;
}
.box_102 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/472e414a94e5320699c99b800b7c44a2)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.box_103 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/836844dbbe63fda80c11852ae365d588)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_90 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_104 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/a57f4ec167cd4608b5771e7e8c97f097_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_259 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 236px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_79 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 110px;
}
.image_80 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_20 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_60 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/59776abeebd98a4ac47d21d74e1dd8a3)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 2672px;
  top: 634px;
}
.box_105 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/e7572e9495c203e0c572879e8dd0c1a1)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.block_61 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/d08a067f86149358ce5afc66c0b3cb58)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_91 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.block_62 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/b953912bf2f3479f98a3d878aa4be6ec_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_260 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 256px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_81 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 90px;
}
.image_82 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_21 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_63 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/5d9c53652597a73d94129192918b2cf6)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 2145px;
  top: 302px;
}
.group_92 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/13829c238fab899a9158a1acc01c7633)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.group_93 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/900716acdc25a5f355059f2d6bb26e26)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_94 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.group_95 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/62798134530343188c208458e3411238_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_261 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 216px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_83 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 130px;
}
.image_84 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_22 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.text-wrapper_58 {
  height: 38px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/d510cca69556ccb746f130d0d304c194) -9px -125px
  no-repeat;
  background-size: 1036px 219px;
  width: 1027px;
  position: absolute;
  left: 1087px;
  top: 631px;
}
.text_262 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 236px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 9px 0 0 19px;
}
.block_64 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/6f41ca30bf8d331638e025bf0d4b147d)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 2672px;
  top: 301px;
}
.section_26 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/45c3006f408ab6c1c04caa3b09c6df79)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.block_65 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/82e6ed22de33bdb9e186a193c33ff586)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.group_96 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.block_66 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/a47361486ac145be95b6430cc4721de2_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_263 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 244px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_85 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 102px;
}
.image_86 {
  position: absolute;
  left: 331px;
  top: -1px;
  width: 159px;
  height: 5px;
}
.thumbnail_23 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_67 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/3c0b01caf41f9bc1b109fc785ad47138)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 32px;
  top: 634px;
}
.section_27 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/d38a1f469bcb19c9239086506c3828f6)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.box_106 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/0c075e4ce99322cb4978503c318140f9)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.box_107 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_108 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/662e4093fd80432c9235a6bb08f295c6_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_264 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 216px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 16px;
}
.image_87 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 130px;
}
.image_88 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_24 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.block_68 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/f933c0e54665d84eb9c043c91c676ee0)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: absolute;
  left: 32px;
  top: 301px;
}
.section_28 {
  height: 31px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/ae2e51aa6189afccaaa13160fa4be25b)
    0px -1px no-repeat;
  background-size: 494px 33px;
  width: 494px;
  position: relative;
}
.box_109 {
  height: 34px;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/e199b714dd39bc134c6668072ba80f92)
  100% no-repeat;
  background-size: 100% 100%;
  margin-left: 4px;
  width: 154px;
}
.section_29 {
  background-color: rgba(52, 129, 234, 0.29);
  width: 494px;
  height: 1px;
  margin: 30px 0 0 -4px;
}
.box_110 {
  position: absolute;
  left: 0;
  top: 0;
  width: 494px;
  height: 22px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/7c46cc312f3f4650bdb3077b07c542a9_mergeImage.png)
  100% no-repeat;
  background-size: 100% 100%;
}
.text_265 {
  text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
  background-image: linear-gradient(
      180deg,
      rgba(14, 197, 236, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(49, 190, 255, 0.36) 0,
      rgba(239, 252, 254, 0.36) 58.764648%,
      rgba(239, 252, 254, 0.36) 74.87793%
  );
  width: 198px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 35px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 5px 0 0 15px;
}
.image_89 {
  width: 122px;
  height: 14px;
  margin: 9px 10px 0 149px;
}
.image_90 {
  position: absolute;
  left: 301px;
  top: -1px;
  width: 189px;
  height: 5px;
}
.thumbnail_25 {
  position: absolute;
  left: 488px;
  top: 9px;
  width: 7px;
  height: 7px;
}
.image_91 {
  position: absolute;
  left: 0;
  top: -15px;
  width: 24px;
  height: 899px;
}
.image_92 {
  position: absolute;
  left: 3176px;
  top: -15px;
  width: 24px;
  height: 899px;
}
.image_93 {
  position: absolute;
  left: 380px;
  top: 951px;
  width: 2441px;
  height: 24px;
}
.flex-col{
  display: flex;
  flex-direction: column;
}
.flex-row{
  display: flex;
  flex-direction: row;
}
</style>
